// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "Забули пароль?",
   "forgot-password-description":
      "Введіть свою електронну адресу нижче, щоб отримати код підтвердження та відновити пароль",
   email: "Електронна пошта",
   cancel: "Скасувати",
   submit: "Надіслати",
   "menu-section-stakeholders": "Зацікавлені сторони",
   "menu-section-setup": "Налаштування",
   "menu-section-implementation": "Впровадження",
   "menu-section-support": "Підтримка",
   "menu-item-experts": "Експерти",
   "menu-item-approvers": "Затверджувачі",
   "menu-item-organizations": "Організації",
   "menu-item-requests": "Запити",
   "menu-item-assessments": "Оцінювання",
   "menu-item-modules": "Модулі",
   "menu-item-targets": "Цілі",
   "menu-item-workspaces": "Робочі простори",
   "menu-item-tickets": "Заявки",
   "menu-section-organization-management": "Управління організацією",
   "menu-section-my-account": "Мій обліковий запис",
   "menu-item-profile": "Профіль",
   "menu-item-team": "Команда",
   "menu-item-help-desk": "Служба підтримки",

   name: "Ім'я",
   country: "Країна",
   "phone-number": "Номер телефону",
   expertise: "Спеціалізація",
   "disabled-reason": "Причина відключення",
   "not-applicable": "Н/Д",
   export: "Експорт",
   "status-pending": "В очікуванні",
   "status-rejected": "Відхилено",
   "status-active": "Активні",
   "status-disabled": "Відключені",

   "experts-management-title": "Експерти",
   "experts-request-tab": "Заявки експертів",
   "experts-approved-tab": "Затверджені експерти",
   "experts-deleted-button": "Видалені експерти",
   "experts-status-deactivated": "Деактивовані",

   "filter-search-label": "Що ви шукаєте?",
   "search-placeholder": "Пошук",
   "search-by-name-placeholder": "Пошук за іменем",
   "search-task-by-name-placeholder": "Пошук завдання за назвою",
   "search-module-by-name-placeholder": "Пошук модуля за назвою",
   "search-workspace-by-name-placeholder": "Пошук робочого простору за назвою",
   "search-assessment-by-name-placeholder": "Пошук оцінювання за назвою",
   "search-expert-by-name-placeholder": "Пошук експерта за іменем",
   "search-request-by-name-placeholder": "Пошук заявки за назвою організації-заявника",
   "search-request-by-email-placeholder": "Пошук заявки за електронною адресою організації-заявника",
   "search-request-by-name-or-email-placeholder": "Пошук за назвою або електронною адресою",
   "search-invoice-by-name-placeholder": "Пошук рахунку за назвою",
   "search-organization-by-name-placeholder": "Пошук організації за назвою",
   "filter-by-type-placeholder": "Фільтр за типом",
   "filter-by-start-date-placeholder": "Фільтр за датою початку",
   "filter-by-end-date-placeholder": "Фільтр за датою завершення",
   "filter-by-year-placeholder": "Фільтр за роком",
   "filter-tasks-by-assigned-member-placeholder": "Фільтр завдань за призначеним учасником",
   "filter-tasks-by-status-placeholder": "Фільтр завдань за статусом",
   "filter-workspace-request-by-status-placeholder": "Фільтр заявок робочого простору за статусом",
   "filter-workspace-by-country-placeholder": "Фільтр робочих просторів за країною",
   "filter-experts-by-country-placeholder": "Фільтр експертів за країною",
   "filter-by-submission-date-placeholder": "Фільтр за датою подання",
   "filter-by-assessments-placeholder": "Фільтр за оцінюваннями",
   "filter-by-assessment-placeholder": "Фільтр за оцінюванням",
   "filter-by-workspace-placeholder": "Фільтр за робочим простором",
   "filter-by-score-placeholder": "Фільтр за оцінкою",
   "filter-by-country-placeholder": "Фільтр за країною",
   "filter-by-operating-countries-placeholder": "Фільтр за країнами діяльності",
   "filter-by-sectors-placeholder": "Фільтр за секторами",
   "export-organizations-button": "Експорт організацій",
   "filter-by-module-placeholder": "Фільтр за модулем",
   "filter-by-round-placeholder": "Фільтр за раундом",
   "filter-by-section-placeholder": "Фільтр за секцією",
   "filter-by-owner-placeholder": "Фільтр за власником",
   "search-by-its-name-placeholder": "Пошук за іменем",
   "guided-assessment": "Кероване оцінювання",
   "self-assessment": "Самооцінювання",
   "clear-all-button": "Очистити все",
   "filters-button": "Фільтри",
   workspace: "Робочий простір",
   assessment: "Оцінювання",
   score: "Оцінка",
   city: "Місто",
   "operating-countries": "Країни діяльності",
   sectors: "Сектори",
   type: "Тип",
   organizations: "Організації",
   "select-workspace-placeholder": "Виберіть робочий простір",
   "select-assessment-placeholder": "Виберіть оцінювання",
   "select-score-range-placeholder": "Виберіть діапазон оцінок",
   "select-country-placeholder": "Виберіть країну",
   "select-base-city-placeholder": "Виберіть ваше базове місто",
   "select-sectors-placeholder": "Виберіть сектори",
   "select-type-placeholder": "Виберіть тип",

   "toast-oops-title": "Ой! Виникла проблема!",
   "toast-request-accepted-success-title": "Заявку успішно прийнято!",
   "toast-request-accepted-success-description":
      "Цю заявку було успішно прийнято, відповідь буде надіслано користувачу, який подав заявку.",
   "toast-request-accept-error-description":
      "Виникла проблема під час прийняття цієї заявки, спробуйте ще раз.",
   "toast-request-rejected-success-title": "Заявку успішно відхилено!",
   "toast-request-rejected-success-description":
      "Цю заявку було успішно відхилено, відповідь буде надіслано користувачу, який подав заявку.",
   "toast-request-reject-error-description":
      "Виникла проблема під час відхилення цієї заявки, спробуйте ще раз.",
   "toast-requests-accepted-success-title": "Заявки успішно прийнято!",
   "toast-requests-accepted-success-description":
      "Заявки було успішно прийнято, відповідь буде надіслано користувачам, які подали заявки.",
   "toast-requests-accept-error-description":
      "Виникла проблема під час прийняття цих заявок, спробуйте ще раз.",
   "toast-requests-rejected-success-title": "Заявки успішно відхилено!",
   "toast-requests-rejected-success-description":
      "Заявки було успішно відхилено, відповідь буде надіслано користувачам, які подали заявки.",
   "toast-requests-reject-error-description":
      "Виникла проблема під час відхилення цих заявок, спробуйте ще раз.",
   "approve-all-button": "Прийняти всі",
   "reject-all-button": "Відхилити всі",

   "search-target-placeholder": "Пошук цілі за назвою оцінювання або модуля",
   "show-active-rounds-checkbox": "Показати активні раунди",

   "general-score-column": "Загальна оцінка",
   "submissions-column": "Подання",
   "tasks-column": "Завдання",
   "areas-complete-text": "напрямків завершено",
   "organizations-progress-summary-title": "Зведення прогресу організацій",
   "export-progress-summary-button": "Експортувати зведення прогресу",
   "select-module-performance-label": "Виберіть модуль, щоб побачити ефективність організацій",
   "all-modules-placeholder": "Всі модулі",

   "registration-request-tab": "Заявка на реєстрацію",
   "workspace-request-tab": "Заявка на робочий простір",
   "assessment-request-tab": "Заявка на оцінювання",
   "status-approved": "Затверджено",
   "requesting-user-column": "Користувач-заявник",
   "request-date-column": "Дата заявки",
   "approval-date-column": "Дата затвердження",
   "processed-by-column": "Опрацював(ла)",
   "workspace-name-column": "Назва робочого простору",
   "assessment-name-column": "Назва оцінювання",
   "consultant-name-column": "Ім'я консультанта",
   "rejection-date-column": "Дата відхилення",
   "accept-request-title": "Прийняти заявку",
   "accept-request-button": "Прийняти заявку",
   "accept-request-description": "Ви збираєтеся прийняти цю заявку. Цю дію неможливо скасувати.",
   "reject-request": "Відхилити заявку",
   "reject-request-description": "Ви збираєтеся відхилити цю заявку. Цю дію неможливо скасувати.",
   "confirm-continue-text": "Ви впевнені, що хочете продовжити?",
   "reject-button": "Відхилити",
   "approve-button": "Затвердити",
   "organization-request-title": "Заявка організації",
   "foundation-label": "Дата заснування",
   "address-label": "Адреса",
   "organization-sectors-label": "Сектори організації",
   "organization-type-label": "Тип організації",
   "organization-size-label": "Розмір організації",
   "organization-name-label": "Назва організації",
   "organization-description-label": "Опис організації",

   "organization-deleted-success-title": "Організацію успішно видалено!",
   "organization-deleted-success-description": "Цю організацію було успішно видалено.",
   "organization-delete-error-description":
      "Виникла проблема під час видалення цієї організації, спробуйте ще раз.",
   "organization-restored-success-title": "Організацію успішно відновлено!",
   "organization-restored-success-description": "Цю організацію було успішно відновлено.",
   "organization-restore-error-description":
      "Виникла проблема під час вимкнення цієї організації, спробуйте ще раз.",
   "organization-restore-failed-error-description":
      "Виникла проблема з відновленням цієї організації, будь ласка, спробуйте ще раз.",
   "organization-disabled-success-title": "Організацію успішно вимкнено!",
   "organization-disabled-success-description": "Цю організацію успішно вимкнено.",
   "disable-organization-title": "Вимкнути організацію",
   "disable-organization-description-text":
      "Ви збираєтеся вимкнути цю організацію. Вона буде переміщена до списку вимкнених організацій, доки не буде відновлена.",
   "reason-for-disabling-label": "Причина вимкнення",
   "disable-organization-reason-placeholder":
      "Будь ласка, вкажіть причину вимкнення цієї організації",
   "disable-button": "Вимкнути",
   "restore-organization-title": "Відновити організацію",
   "registration-date-column": "Дата реєстрації",
   "organization-list-title": "Список організацій",
   "enroll-organizations-button": "Зареєструвати в іншому робочому просторі",
   "registered-organizations-label": "Зареєстровані організації",
   "average-score-label": "Середній бал",
   "registered-as-of-text": "Зареєстровано з",
   "social-networks-title": "Соціальні мережі",
   "offices-title": "Офіси",
   "ongoing-projects-label": "Поточні проєкти",
   "members-label": "Учасники",
   "representative-label": "Представник",
   "representative-name-label": "Ім'я представника",
   "representative-title-label": "Посада представника",
   "representative-location-label": "Місцезнаходження представника",
   "representative-phone-label": "Телефон представника",
   "representative-skype-label": "Skype представника",
   "representative-email-label": "Електронна пошта представника",

   "workspace-required-validation": "Робочий простір є обов'язковим",
   "organizations-enrolled-success-title": "Організації успішно зареєстровано!",
   "organizations-enrolled-success-description":
      "Ці організації успішно зареєстровано в обраному вами робочому просторі.",
   "organizations-enroll-error-description":
      "Виникла проблема під час реєстрації цих організацій, спробуйте ще раз.",
   "enroll-organization-modal-title": "Зареєструвати організацію в іншому робочому просторі",
   "select-workspace-to-enroll-label": "Виберіть робочий простір для реєстрації організацій",
   "confirm-button": "Підтвердити",
   "delete-button": "Видалити",
   "delete-organization-title": "Видалити організацію",
   "delete-organization-description": "Ви збираєтеся видалити цю організацію. Цю дію неможливо скасувати.",

   "update-successful-message": "Оновлення пройшло успішно",
   "max-50-symbols-validation": "Максимум 50 символів",
   "min-3-symbols-validation": "Мінімум 3 символи",
   "invalid-email-validation": "Недійсна електронна пошта",
   "required-validation": "Обов'язково",
   "edit-organization-details-title": "Редагувати дані організації",
   "project-number-title": "Номер проєкту",
   "ongoing-project-number-label": "Кількість поточних проєктів",
   "social-label": "Соціальні мережі",
   "website-label": "Веб-сайт",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "Назад",
   "update-button": "Оновити",

   "representative-removed-success-title": "Дані представника успішно видалено!",
   "representative-removed-success-description": "Інформацію про дані вашого представника видалено.",
   "representative-remove-error-description":
      "Виникла проблема під час видалення інформації про представника, спробуйте ще раз.",
   "profile-status-changed-title": "Статус вашого профілю змінено!",
   "profile-status-changed-description": "Статус вашого профілю успішно змінено.",
   "profile-status-change-error-description":
      "Виникла проблема під час зміни статусу профілю, спробуйте ще раз.",
   "go-back-to-organizations-link": "Повернутися до організацій",
   "print-profile-button": "Друкувати профіль",
   "make-profile-public-button": "Зробити профіль публічним",
   "make-profile-private-button": "Зробити профіль приватним",
   "complete-profile-reminder-title": "Не забудьте заповнити свій профіль!",
   "complete-profile-reminder-description":
      "Збільште свою видимість у спільноті завдяки повному та публічному профілю.",
   "complete-profile-now-button": "Заповнити профіль зараз",
   "profile-status-label": "Статус профілю",
   "private-status": "Приватний",
   "public-status": "Публічний",
   "organization-email-label": "Електронна пошта організації",
   "base-country-label": "Основна країна",
   "zip-code-label": "Поштовий індекс",
   "about-label": "Про організацію",
   "foundation-date-label": "Дата заснування",
   "organizations-size-label": "Розмір організацій",
   "countries-where-operate-label": "Країни, де працює організація",
   "sector-that-works-label": "Сектор, у якому працює організація",
   "representative-details-title": "Дані представника",
   "delete-all-representative-info-button": "Видалити всю інформацію про представника",
   "add-representative-details-button": "Додати дані представника",
   "no-information-available-text": "Інформація недоступна",
   "location-label": "Місцезнаходження",
   "edit-representative-details-button": "Редагувати дані представника",
   "assessments-scores-title": "Результати оцінювань",
   "assessments-scores-description": "Перегляньте результати цієї організації в завершених оцінюваннях.",
   "select-self-assessment-placeholder": "Виберіть самооцінювання",
   "no-self-assessment-yet-title": "Ще немає самооцінювання",
   "no-self-assessment-yet-description": "Ця організація ще не завершила самооцінювання",
   "select-guided-assessment-placeholder": "Виберіть кероване оцінювання",
   "no-guided-assessment-yet-title": "Ще немає керованого оцінювання",
   "no-guided-assessment-yet-description": "Ця організація ще не завершила кероване оцінювання",
   "team-member-list-title": "Список членів команди",
   "team-member-list-description":
      "Додайте членів своєї команди та співпрацюйте, щоб зміцнити свою організацію. Цей розділ видно лише вам. Навіть якщо ваш профіль публічний, ніхто інший не зможе побачити доданих вами учасників.",
   "latest-round-label": "Останній раунд",
   "size-label": "Розмір",
   "select-number-placeholder": "Виберіть число",
   "select-date-placeholder": "Виберіть дату",

   "profile-updated-success-title": "Профіль успішно оновлено!",
   "profile-updated-success-description": "Інформацію вашого профілю коректно оновлено.",
   "profile-update-error-description":
      "Виникла проблема під час оновлення інформації профілю, спробуйте ще раз.",
   "international-name-required-validation": "Міжнародна назва обов'язкова",
   "date-of-establishment-required-validation": "Дата заснування обов'язкова",
   "address-required-validation": "Адреса обов'язкова",
   "zip-code-required-validation": "Поштовий індекс обов'язковий",
   "email-required-validation": "Електронна пошта обов'язкова",
   "invalid-phone-number-validation": "Недійсний номер телефону",
   "phone-number-required-validation": "Номер телефону обов'язковий",
   "at-least-one-sector-required-validation": "Потрібен щонайменше один сектор",
   "organization-size-required-validation": "Розмір організації обов'язковий",
   "at-least-one-country-required-validation": "Потрібна щонайменше одна країна",
   "base-country-required-validation": "Основна країна обов'язкова",
   "city-required-validation": "Місто обов'язкове",
   "edit-profile-title": "Редагувати профіль",
   "organization-details-tab": "Дані організації",
   "international-name-placeholder": "Міжнародна назва",
   "description-placeholder": "Опис",
   "foundation-year-label": "Рік заснування",
   "select-organization-size-placeholder": "Виберіть розмір організації",
   "countries-where-operates-label": "Країни, де працює організація",
   "select-operating-countries-placeholder": "Виберіть країни діяльності",
   "working-sector-label": "Сектор роботи",
   "select-sectors-alt-placeholder": "Виберіть сектори",
   "contact-information-tab": "Контактна інформація",
   "organizations-email-label": "Електронна пошта організації",
   "select-base-country-placeholder": "Виберіть основну країну",
   "select-a-city-placeholder": "Виберіть місто",
   "save-changes-button": "Зберегти зміни",

   // Profile information page (account profile edit forms)
   "name-label": "Ім'я",
   "city-label": "Місто",
   "birthdate-label": "Дата народження",
   "select-your-prefix": "Виберіть",
   "area-of-expertise-colon-label": "Сфера експертизи:",
   "years-suffix-label": "років",
   "professional-details-title": "Професійні деталі",
   "enter-current-password-placeholder": "Введіть поточний пароль",
   "enter-new-password-placeholder": "Введіть новий пароль",
   "enter-new-password-again-placeholder": "Введіть новий пароль ще раз",
   "enter-your-email-placeholder": "Введіть свою електронну пошту",

   // Login information page (LoginInfo.js)
   "account-information-label": "Інформація про обліковий запис",
   "email-label": "Електронна пошта",
   "current-password-label": "Поточний пароль",
   "new-password-label": "Новий пароль",
   "password-hint-intro-text": "Щоб захистити свій обліковий запис, ваш пароль повинен містити щонайменше:",
   "password-hint-length": "8 символів",
   "password-hint-uppercase": "Одну велику літеру",
   "password-hint-lowercase": "Одну малу літеру",
   "password-hint-number": "Одну цифру",
   "password-hint-special": "Один спеціальний символ",
   "change-password-here-text": "Ви можете змінити пароль тут",
   "email-changed-success-title": "Електронну пошту успішно змінено!",
   "email-changed-success-description": "Вашу електронну пошту успішно оновлено.",
   "email-update-error-description": "Виникла проблема під час зміни вашої електронної пошти, спробуйте ще раз.",
   "password-changed-success-title": "Пароль успішно змінено!",
   "password-changed-success-description": "Ваш пароль успішно оновлено.",
   "password-update-error-description": "Виникла проблема під час зміни вашого пароля, спробуйте ще раз.",
   "current-password-required-validation": "Поточний пароль обов'язковий",
   "new-password-required-validation": "Новий пароль обов'язковий",
   "confirm-new-password-required-validation": "Підтвердження нового пароля обов'язкове",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "Керування обліковим записом",
   "deactivate-account-title": "Деактивувати обліковий запис",
   "deactivate-account-description":
      "Ви можете деактивувати свій обліковий запис тут. Це зробить ваш обліковий запис тимчасово непридатним для використання. Однак ця дія повністю оборотна, і",
   "deactivate-account-explanation":
      "ви можете повторно активувати свій обліковий запис у будь-який час, просто увійшовши знову.",
   "delete-account-title": "Видалити обліковий запис",
   "delete-account-description":
      "Видалення вашого облікового запису остаточно видалить усі ваші дані з нашої системи.",
   "delete-account-explanation":
      "Ця дія незворотна, тобто після видалення облікового запису ви не зможете відновити жодну зі своїх інформації чи вмісту.",
   "delete-account-explanation-2": "Якщо ви впевнені, що хочете продовжити,",
   "delete-account-explanation-3":
      "майте на увазі, що ви втратите доступ до всіх послуг і даних, пов'язаних із вашим обліковим записом.",
   "delete-account-modal-title": "Видаліть свій обліковий запис",
   "deactivate-account-modal-title": "Деактивуйте свій обліковий запис",
   "delete-account-modal-description": "Нам шкода, що ви йдете, але ми поважаємо ваше рішення!",
   "deactivate-account-modal-description":
      "Думаєте про перерву? Деактивація облікового запису — це завжди варіант.",
   "confirm-account-deletion-title": "Підтвердити видалення облікового запису",
   "confirm-account-deactivation-title": "Підтвердити деактивацію облікового запису",
   "confirm-delete-account-description":
      "Ви збираєтеся остаточно видалити свій обліковий запис і дані.",
   "confirm-deactivate-account-description": "Ви збираєтеся деактивувати свій обліковий запис.",
   "confirm-action-other-desc": "Ви впевнені, що хочете продовжити?",
   "delete-reason-1": "Мені більше не потрібна ця послуга.",
   "delete-reason-2": "Я знайшов іншу послугу, яка краще відповідає моїм потребам.",
   "delete-reason-3": "У мене був поганий досвід.",
   "delete-reason-4": "Мене турбує конфіденційність моїх даних.",
   "deactivate-reason-1": "Мені потрібна коротка перерва.",
   "deactivate-reason-2": "Зараз я занадто зайнятий, щоб користуватися платформою.",
   "deactivate-reason-3": "Я вирішую особисті питання.",
   "deactivate-reason-4": "Я хочу зосередитися на інших пріоритетах наразі.",
   "other-please-specify-label": "Інше (будь ласка, вкажіть)",
   "enter-your-answer-placeholder": "Введіть свою відповідь тут",
   "delete-account-feedback-prompt":
      "Ми хотіли б почути вашу думку. Чи можете ви поділитися, чому ви розглядаєте можливість видалення свого облікового запису?",
   "deactivate-account-feedback-prompt":
      "Ми хотіли б почути вашу думку. Чи можете ви поділитися, чому ви розглядаєте можливість деактивації свого облікового запису?",
   "delete-account-followup-question":
      "Дякуємо, що були з нами. Чи є щось, що ми могли б зробити, щоб покращити ваш досвід?",
   "deactivate-account-followup-question":
      "Ми завжди прагнемо покращуватися. Якщо у вас є пропозиції чи коментарі, ми будемо раді їх почути",
   "delete-account-error-description":
      "Виникла проблема під час видалення вашого облікового запису, спробуйте ще раз.",
   "deactivate-account-error-description":
      "Виникла проблема під час деактивації вашого облікового запису, спробуйте ще раз.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "Оберіть ідеальний план для себе",
   "billed-annually-text": "Оплата щорічно",
   "workspaces-suffix-label": "робочих просторів",
   "members-suffix-label": "учасників",
   "data-storage-limit-suffix-label": "ліміт зберігання даних",
   "see-all-plan-details-link": "Переглянути всі деталі плану",
   "plan-selected-label": "План вибрано",
   "select-this-plan-button": "Вибрати цей план",
   "view-billing-portal-button": "Переглянути портал виставлення рахунків",
   "checkout-button": "Оформити оплату",
   "active-subscription-error-description":
      "У користувача вже є активна підписка. Будь ласка, оберіть інший план.",
   "payment-billing-error-description": "Виникла проблема під час оплати, спробуйте ще раз.",
   "purchase-successful-title": "Покупку здійснено успішно!",
   "payment-processed-success-text": "Ваш платіж успішно оброблено.",
   "thank-you-for-purchase-text": "Дякуємо за вашу покупку!",
   "go-back-to-payment-info-text": "Повернутися до інформації про оплату",
   "purchase-failed-title": "Не вдалося здійснити покупку",
   "purchase-failed-description":
      "На жаль, ваша остання спроба покупки не вдалася. Можливо, виникла проблема з обробкою платежу або з наданою інформацією. Будь ласка, перевірте дані платежу та спробуйте ще раз.",
   "apologize-inconvenience-text": "Перепрошуємо за незручності та дякуємо за терпіння.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "Мінімум 3 символи",
   "max-50-symbols-validation": "Максимум 50 символів",
   "invalid-organization-email-validation": "Недійсна електронна пошта організації",
   "organization-address-required-validation": "Адреса організації обов'язкова",
   "operating-countries-required-validation": "Країни діяльності обов'язкові",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "дія з обліковим записом",
   "account-deactivated-notice-text": "Ваш обліковий запис успішно деактивовано на ваш запит.",
   "account-deleted-notice-text": "Ваш обліковий запис успішно видалено на ваш запит.",
   "positive-experience-farewell-text":
      "Ми віримо, що у вас був позитивний досвід з нами, і хочемо, щоб ви знали, що ми завжди будемо раді вітати вас знову, коли б ви не вирішили повернутися.",
   "kaporg-best-regards-text": "З повагою, команда KAPorg.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "Редагувати фото профілю",
   "change-profile-picture-button": "Змінити фото профілю",
   "delete-profile-picture-button": "Видалити фото профілю",
   "profile-picture-updated-success-title": "Фото профілю успішно оновлено!",
   "profile-picture-updated-success-description": "Ваше фото профілю успішно оновлено.",
   "profile-picture-update-error-description":
      "Виникла проблема під час оновлення фото профілю, спробуйте ще раз.",
   "profile-picture-deleted-success-title": "Фото профілю успішно видалено!",
   "profile-picture-deleted-success-description": "Ваше фото профілю видалено.",
   "profile-picture-delete-error-description":
      "Виникла проблема під час видалення фото профілю, спробуйте ще раз.",

   "name-required-validation": "Ім'я обов'язкове",
   "gender-required-validation": "Стать обов'язкова",
   "role-required-validation": "Роль обов'язкова",
   "team-member-added-success-title": "Учасника команди успішно додано!",
   "team-member-added-success-description": "Цього учасника успішно додано до бази даних вашої команди.",
   "team-member-add-error-description":
      "Виникла проблема під час додавання цього учасника до бази даних вашої команди, спробуйте ще раз.",
   "add-new-member-title": "Додати нового учасника",
   "gender-label": "Стать",
   "select-gender-placeholder": "Виберіть стать",
   "role-label": "Роль",
   "select-role-placeholder": "Виберіть роль",
   "make-my-profile-public-button": "Зробити мій профіль публічним",
   "make-my-profile-private-button": "Зробити мій профіль приватним",
   "make-profile-public-title": "Зробити профіль публічним",
   "make-profile-private-title": "Зробити профіль приватним",
   "profile-visibility-notice-public":
      "Зробивши свою національну організацію публічною, донори та експерти зможуть бачити вашу інформацію та результати. Тому радимо переконатися, що вся ваша інформація заповнена, перш ніж робити її публічною.",
   "profile-visibility-notice-private":
      "Зробивши свою національну організацію приватною, донори та експерти зможуть бачити вашу інформацію та результати. Тому радимо переконатися, що вся ваша інформація заповнена, перш ніж робити її приватною.",
   "delete-member-title": "Видалити учасника",
   "delete-member-description": "Ви збираєтеся видалити цього учасника. Цю дію неможливо скасувати.",
   "delete-all-representative-details-title": "Видалити всі дані представника",
   "delete-representative-info-description-1":
      "Ви збираєтеся видалити всю інформацію про вашого представника.",
   "delete-representative-info-description-2": "За бажанням ви можете додати її знову пізніше.",
   "delete-representative-info-description-3":
      "Пам'ятайте, що повний профіль має вирішальне значення для кращої видимості та можливостей для контактів у спільноті.",
   "organizations-management-title": "Управління організаціями",

   "representative-updated-success-title": "Дані представника успішно оновлено!",
   "representative-updated-success-description":
      "Інформацію про дані вашого представника коректно оновлено.",
   "representative-update-error-description":
      "Виникла проблема під час оновлення інформації про представника, спробуйте ще раз.",
   "edit-representative-detail-title": "Редагувати дані представника",
   "full-name-label": "Повне ім'я",
   "phone-label": "Телефон",
   "edit-representative-button": "Редагувати представника",
   "representative-added-success-title": "Дані представника успішно додано!",
   "representative-added-success-description":
      "Інформацію про дані вашого представника коректно додано.",
   "representative-add-error-description":
      "Виникла проблема під час додавання інформації про представника, спробуйте ще раз.",
   "create-representative-detail-title": "Створити нові дані представника",

   "team-member-removed-success-title": "Учасника команди успішно видалено!",
   "team-member-removed-success-description":
      "Цього учасника успішно видалено з бази даних вашої команди.",
   "team-member-remove-error-description":
      "Виникла проблема під час видалення цього учасника з бази даних вашої команди, спробуйте ще раз.",
   "fullname-column": "Повне ім'я",
   "member-search-label": "Якого учасника ви шукаєте?",
   "search-member-by-name-placeholder": "Пошук учасника за іменем",
   "add-member-button": "Додати учасника",
   "new-member-button": "Новий учасник",
   "birthdate-label": "Дата народження",
   "email-field-label": "Електронна пошта",
   "name": "Ім'я",
   "email": "Електронна пошта",
   "cancel": "Скасувати",
   "no-assessments-listed-text": "Немає оцінювань у списку",
   "remaining-months-days-text": "{months} міс., {days} дн.",
   "more-actions-label": "Більше дій",
   "sort-ascending-alt": "Сортувати за зростанням",
   "sort-descending-alt": "Сортувати за спаданням",
   "error-unauthorized-text": "Вибачте, у вас немає доступу до цієї сторінки.",
   "error-page-not-found-text": "Вибачте, сторінки, яку ви відвідали, не існує.",
   "error-oops-title": "Ой...",
   "back-home-button": "На головну",
   "error-something-wrong-text": "Схоже, щось пішло не так. Ми працюємо над цим",

   "requests-management-title": "Управління запитами",
   "archived-assessments-link": "Заархівовані оцінювання",
   "deleted-assessments-link": "Видалені оцінювання",
   "add-new-assessment-button": "Нове оцінювання",
   "assessment-list-title": "Оцінювання",
   "archive-button": "Архівувати",
   "archive-assessment-title": "Архівувати оцінювання",
   "delete-assessment-title": "Видалити оцінювання",
   "archive-assessment-description": "Ви збираєтеся архівувати це оцінювання.",
   "delete-assessment-description": "Ви збираєтеся видалити це оцінювання.",

   "start-date-after-previous-end-validation":
      "Дата початку має бути пізнішою за попередню дату закінчення",
   "end-date-after-start-validation": "Дата закінчення має бути пізнішою за дату початку",
   "assessment-name-empty-validation": "Назва оцінювання не може бути порожньою",
   "submission-round-label-empty-validation": "Мітка раунду подання не може бути порожньою",
   "date-fields-required-validation": "Поля дати є обов'язковими",
   "start-date-required-validation": "Дата початку обов'язкова",
   "end-date-required-validation": "Дата закінчення обов'язкова",
   "assessment-created-success-title": "Оцінювання успішно створено!",
   "assessment-created-success-description": "Нове оцінювання створено та додано до вашої бази даних.",
   "assessment-create-error-description":
      "Виникла проблема під час створення цього оцінювання, спробуйте ще раз.",
   "assessment-details-title": "Деталі оцінювання",
   "assessment-name-label": "Назва оцінювання",
   "enter-assessment-name-placeholder": "Введіть назву оцінювання",
   "assessment-type-label": "Тип оцінювання",
   "submission-round-label-field": "Мітка раунду подання",
   "enter-submission-round-placeholder": "Введіть раунд подання",
   "start-date-label": "Дата початку",
   "end-date-label": "Дата закінчення",
   "add-new-submission-round-button": "Додати новий раунд подання",
   "dynamic-range-label": "Динамічний діапазон",
   "select-score-range-description":
      "Виберіть діапазон для змінних оцінки вашого оцінювання (до 5)",
   "score-variables-label": "змінні оцінки",
   "from-label": "Від",
   "to-label": "до",
   "score-label-field": "Мітка оцінки",
   "score-description-field": "Опис оцінки",
   "enter-label-description-placeholder": "Введіть опис мітки",
   "add-assessment-button": "Додати оцінювання",
   "assessment-assigned-success-title": "Оцінювання успішно призначено!",
   "assessment-assigned-success-description":
      "Це оцінювання успішно призначено членам вашої команди. Їх буде повідомлено про цю дію.",
   "assessment-assign-error-description":
      "Виникла проблема під час призначення цього оцінювання членам вашої команди, спробуйте ще раз.",
   "assign-assessment-to-team-title": "Призначити оцінювання команді",
   "project-management-label": "Управління проєктом",

   "assessment-updated-success-title": "Оцінювання успішно оновлено!",
   "assessment-updated-success-description": "Це оцінювання правильно оновлено.",
   "assessment-update-error-description":
      "Виникла проблема під час оновлення цього оцінювання, спробуйте ще раз.",
   "edit-assessment-title": "Редагувати оцінювання",
   "edit-assessment-of-team-title": "Редагувати оцінювання цієї команди",
   "select-project-management-placeholder": "Виберіть керівника проєкту",
   "module-assigned-success-title": "Модуль успішно призначено!",
   "module-assigned-success-description":
      "Цей модуль успішно призначено членам вашого персоналу. Їх буде повідомлено про цю дію.",
   "module-unassigned-success-title": "Призначення модуля успішно скасовано!",
   "module-unassigned-success-description":
      "Призначення цього модуля успішно скасовано співробітником.",
   "module-assign-error-description":
      "Виникла проблема під час призначення цього модуля членам вашого персоналу, спробуйте ще раз.",
   "assign-module-to-members-title": "Призначити модуль учасникам",
   "module-name-label": "Назва модуля",
   "members-to-assign-label": "Учасники, яким буде призначено цей модуль",
   "unassign-button": "Скасувати призначення",
   "assign-module-button": "Призначити модуль",
   "member-required-validation": "Учасник обов'язковий",

   "comparison-created-success-title": "Створено нову версію порівняння!",
   "comparison-created-success-description":
      "Нову версію порівняння успішно створено, вона готова до перегляду.",
   "comparison-create-error-description":
      "Виникла проблема під час створення цієї версії порівняння, спробуйте ще раз.",
   "duplicate-for-comparison-title": "Дублювати для порівняння",
   "duplicate-comparison-description-1":
      "Це створить копію оцінювання та зв'яже обидві версії для порівняння результатів.",
   "duplicate-comparison-description-2":
      "Після дублювання оцінювання та будь-які пов'язані модулі не можна змінювати.",
   "current-assessment-label": "Поточне оцінювання",
   "new-comparison-version-label": "Нова версія порівняння",
   "comparison-suffix-label": "Порівняння",
   "duplicate-comparison-note":
      "Примітка: за потреби ви можете пізніше видалити зв'язок, щоб редагувати їх незалежно, але порівняння більше не буде доступним.",
   "duplicate-button": "Дублювати",
   "assessments-unlinked-success-title": "Оцінювання роз'єднано!",
   "assessments-unlinked-success-description":
      "Оцінювання успішно роз'єднано, і тепер їх можна редагувати незалежно.",
   "assessments-unlink-error-description":
      "Виникла проблема під час роз'єднання оцінювань, спробуйте ще раз.",
   "unlink-assessments-title": "Роз'єднати ці оцінювання?",
   "unlink-assessments-description":
      "Вони більше не будуть пов'язані для порівняння, і перегляд порівняння більше не буде доступним.",
   "original-assessment-label": "Оригінальне оцінювання",
   "duplicated-assessment-label": "Дубльоване оцінювання",
   "unlink-assessments-note": "Примітка: після роз'єднання кожне оцінювання можна редагувати незалежно.",
   "unlink-button": "Роз'єднати",
   "expert-name-column": "Ім'я експерта",
   "years-of-experience-column": "Роки досвіду",
   "expert-cv-column": "Резюме експерта",
   "cv-link-text": "Посилання на резюме",
   "no-cv-available-text": "Резюме недоступне",
   "areas-of-expertise-column": "Сфери експертизи",
   "select-expert-request-access-title": "Виберіть експерта та подайте запит на доступ",
   "first-choose-expert-subtitle": "Спочатку виберіть експерта",
   "choose-expert-guide-hint": "Виберіть експерта для керівництва вашим оцінюванням",
   "request-access-button": "Запит на доступ",
   "go-back-experts-list-link": "Повернутися до списку експертів",
   "no-description-available-text": "Опис недоступний",
   "no-expertise-listed-text": "Експертиза не вказана",
   "nationality-label": "Національність",
   "no-nationality-listed-text": "Національність не вказана",
   "country-of-residence-label": "Країна проживання",
   "no-country-of-residence-text": "Немає країни проживання",
   "no-operating-countries-listed-text": "Країни діяльності не вказані",
   "linkedin-profile-label": "Профіль LinkedIn",
   "no-linkedin-profile-text": "Профіль LinkedIn не надано",
   "no-phone-number-listed-text": "Номер телефону не вказаний",
   "highest-degree-label": "Найвищий здобутий ступінь",
   "no-highest-degree-listed-text": "Найвищий здобутий ступінь не вказаний",
   "fields-of-study-label": "Галузі навчання",
   "no-study-fields-listed-text": "Галузі навчання не вказані",
   "educational-institution-label": "Навчальний заклад",
   "no-educational-institution-listed-text": "Навчальний заклад не вказаний",
   "languages-label": "Мови",
   "no-languages-listed-text": "Мови не вказані",
   "cv-label": "Резюме",
   "no-cv-listed-text": "Резюме не вказане",
   "certification-training-label": "Сертифікат або спеціальне навчання",
   "no-certification-listed-text": "Сертифікат або спеціальне навчання не вказано",

   "archived-assessments-list-title": "Список архівованих оцінювань",
   "deleted-assessments-title": "Видалені оцінювання",
   "delete-permanently-button": "Видалити назавжди",
   "unarchive-assessments-button": "Розархівувати оцінювання",
   "restore-assessments-button": "Відновити оцінювання",
   "deleted-assessments-description":
      "Тут ви можете переглядати та відновлювати видалені оцінювання. Будь-яке оцінювання, яке не буде відновлено протягом 60 днів, буде видалено назавжди.",
   "delete-assessment-permanently-title": "Видалити оцінювання назавжди",
   "delete-assessments-permanently-title": "Видалити оцінювання назавжди",
   "delete-selected-assessment-permanently-description":
      "Ви збираєтеся назавжди видалити вибране оцінювання.",
   "delete-selected-assessments-permanently-description":
      "Ви збираєтеся назавжди видалити вибрані оцінювання.",
   "action-cannot-be-undone-confirm-text":
      "Цю дію неможливо скасувати. Ви впевнені, що хочете продовжити?",

   "request-sent-success-title": "Запит успішно надіслано!",
   "request-sent-success-description":
      "Ваш запит надіслано адміністратору. Щойно на запит буде надано відповідь, ви отримаєте електронний лист із відповіддю.",
   "request-send-error-description": "Виникла проблема під час надсилання вашого запиту, спробуйте ще раз.",
   "request-rejected-title": "О ні! Здається, ваш запит відхилено",
   "request-rejected-description-line1":
      "Наразі ви не можете отримати доступ до цього оцінювання, оскільки ваш запит було відхилено.",
   "request-rejected-description-line2": "Але не хвилюйтеся! Ви можете знову подати запит на доступ.",
   "request-pending-title": "Ви вже подали запит на доступ до цього оцінювання!",
   "request-pending-description-line1":
      "Ваш запит надіслано адміністратору цього оцінювання. Щойно на запит буде надано відповідь, ви отримаєте електронний лист із відповіддю.",
   "request-pending-description-line2": "Ми зв'яжемося з вами якомога швидше.",
   "request-access-title": "Подати запит на доступ до цього оцінювання",
   "request-access-description-part1": "Розблокуйте це кероване оцінювання, щоб",
   "request-access-description-part2": "ми могли призначити наших експертів",
   "request-access-description-part3": "з вашої сфери діяльності, щоб",
   "request-access-description-part4": "безпосередньо підтримувати вас протягом процесу оцінювання",
   "request-access-description-part5":
      "і допомогти вам знайти способи побудови кращих партнерств та забезпечення фінансування для майбутніх програм.",

   "guided-assessments-title": "Керовані оцінювання",
   "assessments-list-title": "Список оцінювань",
   "organizations-name-column": "Назва організації",
   "assessment-column": "Оцінювання",
   "status-column": "Статус",
   "not-started-status": "Не розпочато",
   "in-progress-status": "У процесі",
   "completed-status": "Завершено",

   "success-title": "Успіх",
   "module-submitted-success-description": "Модуль успішно надіслано",
   "no-submission-rounds-text": "Немає раундів подання",
   "submission-rounds-title": "Раунди подання",
   "round-target-label": "Ціль",
   "module-submitted-modal-title": "Ви успішно надіслали цей модуль!",
   "next-round-active-description":
      "Будь ласка, поверніться до цього оцінювання, коли активується наступний раунд подання.",
   "remaining-time-current-round-label": "Час, що залишився до кінця поточного раунду",
   "start-label": "Початок",
   "end-label": "Кінець",
   "linked-modules-title": "Пов'язані модулі",
   "no-linked-modules-text": "Немає пов'язаних модулів",
   "finished-status": "Завершено",
   "completed-text": "завершено",

   "assigned-to-label": "Призначено на",
   "assign-member-button": "Призначити учасника",
   "submitted-at-label": "Надіслано",
   "edit-assignment-button": "Редагувати призначення",
   "assign-to-team-button": "Призначити команді",
   "assessment-assigned-to-label": "Оцінювання призначено:",
   "expert-modules-description":
      "Це модулі, на які відповість обраний вами експерт. Щойно експерт надішле модулі, ви зможете переглянути результати та відповіді в розділі Результати.",

   "no-self-assessments-yet-title": "Схоже, у цьому робочому просторі ще немає самооцінювань!",
   "no-guided-assessments-yet-title":
      "Схоже, у цьому робочому просторі ще немає керованих оцінювань!",
   "work-on-guided-assessments-instead-description":
      "Але не хвилюйтеся, натомість ви можете попрацювати над керованими оцінюваннями.",
   "work-on-self-assessments-instead-description":
      "Але не хвилюйтеся, натомість ви можете попрацювати над самооцінюваннями.",

   "name-column": "Назва",
   "type-column": "Тип",
   "created-by-column": "Створено",
   "created-date-column": "Дата створення",
   "edit-action": "Редагувати",
   "founded-label": "Засновано",
   "areas-label": "напрямків",
   "staff-label": "персонал",
   "contact-label": "Контакти",
   "online-label": "Онлайн",
   "unlink-assessment-action": "Від'єднати оцінювання",
   "edit-assessment-alt": "Редагувати оцінювання",
   "archive-assessment-alt": "Архівувати оцінювання",
   "delete-assessment-alt": "Видалити оцінювання",
   "unlink-assessment-alt": "Від'єднати оцінювання",

   "assessment-deleted-success-title": "Оцінювання успішно видалено!",
   "assessment-deleted-success-description":
      "Це оцінювання було успішно видалено з вашої бази даних.",
   "assessment-delete-error-description":
      "Виникла проблема під час видалення цього оцінювання, спробуйте ще раз.",
   "assessments-deleted-success-title": "Оцінювання успішно видалені!",
   "assessments-deleted-success-description":
      "Ці оцінювання були успішно видалені з вашої бази даних.",
   "assessments-delete-error-description":
      "Виникла проблема під час видалення цих оцінювань, спробуйте ще раз.",
   "assessment-restored-success-title": "Оцінювання успішно відновлено!",
   "assessment-restored-success-description": "Це оцінювання було успішно відновлено.",
   "assessment-unarchive-error-description":
      "Виникла проблема під час розархівування цього оцінювання, спробуйте ще раз.",
   "assessments-unarchived-success-title": "Оцінювання успішно розархівовані!",
   "assessments-unarchived-success-description": "Ці оцінювання були успішно розархівовані.",
   "assessments-unarchive-error-description":
      "Виникла проблема під час розархівування цих оцінювань, спробуйте ще раз.",
   "assessment-archived-success-title": "Оцінювання успішно заархівовано!",
   "assessment-archived-success-description": "Це оцінювання було успішно заархівовано.",
   "assessment-archive-error-description":
      "Виникла проблема під час додавання цього оцінювання до архіву, спробуйте ще раз.",
   "assessment-trashed-success-title": "Оцінювання успішно додано до кошика!",
   "assessment-trashed-success-description": "Це оцінювання було успішно додано до кошика.",
   "assessment-trash-error-description":
      "Виникла проблема під час додавання цього оцінювання до кошика, спробуйте ще раз.",

   "assessment-modules-title": "Модулі оцінювання",
   "module-name-column": "Назва модуля",
   "go-to-module-button": "Перейти до модуля",

   "consultant-organization-list-title": "Список консультаційних організацій",
   "country-column": "Країна",
   "progress-column": "Прогрес",
   "submitted-status": "Надіслано",
   "go-to-assessment-button": "Перейти до оцінювання",

   "module-submitted-toast": "Модуль успішно надіслано.",
   "no-permission-submit-module-warning": "У вас немає дозволу на надсилання модуля!",
   "submit-button": "Надіслати",
   "module-submitted-text": "Цей модуль надіслано.",

   "choose-consultant-guide-title": "Оберіть консультанта для супроводу вашого оцінювання",
   "consultant-profile-title": "Профіль консультанта",
   "consultant-label": "Консультант",
   "experience-title": "Досвід",
   "education-title": "Освіта",
   "school-label": "Школа",
   "skills-title": "Навички",
   "select-this-consultant-button": "Обрати цього консультанта",
   "enrolled-guided-assessment-success-title": "Ви успішно зареєстровані на кероване оцінювання!",
   "consultant-contact-soon-description-part1": "Консультант",
   "consultant-contact-soon-description-part2":
      "незабаром зв'яжеться з вами, щоб розпочати ваші оцінювання.",
   "go-to-assessments-button": "Перейти до оцінювань",

   "improve-score-help-title":
      "Якщо ви хочете покращити свій результат і розвинути свою організацію далі, команда KAPorg тут, щоб допомогти вам!",
   "request-guided-assessment-description-part1":
      "Подайте запит на кероване оцінювання зараз, щоб ми могли призначити наших експертів з вашої сфери діяльності для безпосередньої підтримки вас протягом процесу оцінювання та допомогти вам знайти способи побудови кращих партнерств і забезпечення фінансування для майбутніх програм.",
   "request-guided-assessment-description-part2":
      "Подайте запит зараз, і ми зв'яжемося з вами якомога швидше.",
   "request-assessment-code-button": "Запросити код оцінювання",
   "have-assessment-code-button": "У мене є код оцінювання",
   "assessment-code-title": "Код оцінювання",
   "enter-assessment-code-description": "Щоб отримати доступ до вашого оцінювання, введіть код оцінювання нижче",
   "enter-code-here-label": "Введіть свій код тут",
   "please-enter-code-error": "Будь ласка, введіть код",
   "assessment-list-label": "Список оцінювань",
   "select-an-assessment-placeholder": "-Оберіть оцінювання-",
   "select-assessment-error": "Ви повинні обрати оцінювання",
   "submit-request-button": "Надіслати запит",
   "request-assessment-code-title": "Запит коду оцінювання",
   "request-assessment-code-description":
      "Будь ласка, подайте запит на ваше оцінювання, і ми зв'яжемося з вами. Щойно запит буде прийнято, ви отримаєте електронний лист із кодом.",
   "select-assessment-from-list-description": "Оберіть оцінювання зі списку нижче",
   "code-valid-select-consultant-toast": "Ваш код дійсний, і тепер ви можете обрати консультанта",

   "my-modules-tab": "Мої модулі",
   "template-library-tab": "Бібліотека шаблонів",

   "module-deleted-success-title": "Модуль успішно видалено!",
   "module-deleted-success-description": "Цей модуль було успішно видалено з вашої бази даних.",
   "module-delete-error-description":
      "Виникла проблема під час видалення цього модуля, спробуйте ще раз.",
   "module-cannot-be-deleted-error": "Модуль неможливо видалити",
   "preview-action": "Перегляд",
   "download-action": "Завантажити",
   "turn-into-template-action": "Перетворити на шаблон",
   "preview-template-alt": "Переглянути шаблон",
   "edit-module-alt": "Редагувати модуль",
   "download-module-alt": "Завантажити модуль",
   "turn-into-template-alt": "Перетворити на шаблон",
   "delete-module-alt": "Видалити модуль",
   "title-column": "Назва",
   "deleted-modules-button": "Видалені модулі",
   "add-module-button": "Новий модуль",
   "add-module-modal-button": "Додати модуль",
   "add-new-module-title": "Додати новий модуль",
   "add-new-assessment-title": "Додати нову оцінку",
   "survey-status-editing": "Редагується",
   "survey-status-archived": "Заархівовано",
   "survey-status-deployed": "Опубліковано",
   "survey-status-locked": "Заблоковано",

   "how-start-title": "Як бажаєте почати?",
   "create-form-title": "Створити форму",
   "create-form-description":
      "Почніть із порожньої структури, додаючи розділи та запитання по ходу роботи.",
   "import-form-title": "Імпортувати форму",
   "import-form-description": "Завантажте файл із заздалегідь визначеними розділами та запитаннями.",
   "use-template-title": "Використати шаблон",
   "use-template-description":
      "Почніть із форми, вже збереженої в системі, і легко налаштуйте її під свої потреби.",
   "continue-button": "Продовжити",

   "module-details-title": "Деталі модуля",
   "enter-module-name-placeholder": "Введіть назву модуля",
   "enter-module-description-placeholder": "Введіть опис модуля",
   "default-language-label": "Мова за замовчуванням",
   "select-default-language-module-placeholder": "Оберіть мову за замовчуванням для модуля",
   "select-assessment-label": "Обрати оцінювання",
   "select-assessment-module-placeholder": "Оберіть оцінювання модуля",

   "delete-module-title": "Видалити модуль",
   "delete-template-title": "Видалити шаблон",
   "delete-module-confirm-description": "Ви збираєтеся видалити цей модуль. Цю дію неможливо скасувати.",
   "delete-template-confirm-description": "Ви збираєтеся видалити цей шаблон. Цю дію неможливо скасувати.",

   "module-restored-success-title": "Модуль успішно відновлено!",
   "module-restored-success-description": "Цей модуль було успішно відновлено.",
   "module-restore-error-description":
      "Виникла проблема під час відновлення цього модуля, спробуйте ще раз.",
   "deleted-modules-list-title": "Список видалених модулів",
   "restore-modules-button": "Відновити модулі",
   "deleted-modules-description":
      "Тут ви можете переглядати та відновлювати видалені модулі. Будь-який модуль, який не буде відновлено протягом 60 днів, буде видалено назавжди.",

   "module-name-required-validation": "Назва модуля обов'язкова",
   "upload-module-file-label": "Завантажити файл модуля",
   "drag-drop-file-text": "Перетягніть файл сюди або",
   "click-to-select-file-text": "натисніть, щоб вибрати файл",
   "max-file-size-text": "Максимальний розмір файлу: 20 МБ",

   "module-create-error-description": "Виникла проблема під час створення цього модуля, спробуйте ще раз.",
   "make-module-template-label": "Зробити цей модуль шаблоном",

   "not-a-xlsx-file-error": "не є файлом xlsx",
   "upload-valid-xlsx-error": "Будь ласка, завантажте дійсний файл xlsx перед надсиланням.",
   "error-title": "Помилка",
   "survey-imported-success-description": "Модуль успішно імпортовано",
   "survey-import-failed-error": "Не вдалося імпортувати модуль.",
   "copy-file-name-tooltip": "Копіювати назву файлу",
   "copied-tooltip": "Скопійовано!",
   "module-must-have-right-format-text":
      "Ваш модуль повинен мати правильний формат для коректного імпортування.",
   "download-format-link": "Завантажити формат",
   "enter-description-placeholder": "Введіть опис",

   "min-3-characters-validation": "Мінімум 3 символи",
   "language-required-validation": "Мова обов'язкова",
   "assessment-required-validation": "Оцінювання обов'язкове",
   "new-module-suffix": "Новий модуль",

   "edit-module-title": "Редагувати модуль",
   "module-description-label": "Опис модуля",

   "template-deleted-success-title": "Шаблон успішно видалено!",
   "template-deleted-success-description": "Цей шаблон було успішно видалено з вашої бази даних.",
   "template-delete-error-description":
      "Виникла проблема під час видалення цього шаблону, спробуйте ще раз.",
   "edit-template-alt": "Редагувати шаблон",
   "download-template-alt": "Завантажити шаблон",
   "duplicate-template-alt": "Дублювати шаблон",
   "delete-template-alt": "Видалити шаблон",
   "copy-action": "Копіювати",
   "module-title-column": "Назва модуля",
   "created-on-column": "Дата створення",
   "last-updated-column": "Останнє оновлення",

   "copy-suffix-label": "Копія",
   "template-duplicated-success-title": "Шаблон успішно продубльовано!",
   "template-duplicated-success-description":
      "Ваш шаблон успішно продубльовано. Тепер ви можете редагувати та налаштувати нову копію.",
   "template-duplicate-error-description":
      "Виникла проблема під час дублювання цього шаблону, спробуйте ще раз.",
   "copy-template-title": "Копіювати шаблон",
   "copy-template-description":
      "Ви збираєтеся створити шаблон багаторазового використання на основі структури цього модуля. Ви зможете використовувати цей шаблон для швидкого створення нових модулів.",
   "template-name-label": "Назва шаблону",
   "template-name-required-validation": "Назва шаблону обов'язкова",
   "enter-template-name-placeholder": "Введіть назву шаблону",
   "description-optional-label": "(необов'язково)",
   "template-description-hint-placeholder":
      "Короткий нотатка, щоб допомогти вашій команді зрозуміти, коли використовувати цей шаблон",

   "no-templates-found-title": "Шаблонів не знайдено",
   "no-templates-found-description":
      "Наразі немає доступних шаблонів. Спробуйте пізніше або створіть новий!",
   "sections-label": "Розділи:",
   "use-template-button": "Використати шаблон",

   "template-created-success-title": "Шаблон успішно створено!",
   "template-created-success-description":
      "Ваш новий шаблон створено на основі структури цього модуля. Тепер ви можете редагувати його або використовувати для швидкого створення нових модулів.",
   "template-create-error-description":
      "Виникла проблема під час створення цього шаблону, спробуйте ще раз.",
   "convert-module-to-template-title": "Перетворити модуль на шаблон",
   "module-label": "Модуль",
   "structure-logic-copied-note":
      "Примітка: буде скопійовано лише структуру та логіку, відповіді не включатимуться.",
   "create-template-button": "Створити шаблон",

   "fetch-drafts-error": "Не вдалося отримати чернетки",
   "module-saved-draft-success": "Модуль успішно збережено як чернетку",
   "save-draft-error": "Не вдалося зберегти чернетку",
   "reject-module-error": "Не вдалося відхилити модуль",
   "submit-module-error": "Не вдалося надіслати модуль",
   "preview-other-modules-text": "Переглянути інші модулі в цьому оцінюванні",
   "my-saved-drafts-button": "Мої збережені чернетки",
   "save-as-draft-button": "Зберегти як чернетку",
   "processing-text": "Обробка...",
   "submit-module-button": "Надіслати модуль",
   "reject-module-button": "Відхилити модуль",
   "approve-module-button": "Затвердити модуль",

   "change-status-button": "Змінити статус",
   "change-module-status-editing-title": "Змінити статус модуля на Редагується",
   "change-module-status-editing-confirm-description":
      "Ви збираєтеся змінити статус модуля на Редагується.",

   "language-label": "Мова",
   "select-language-placeholder": "Оберіть мову",
   "print-module-button": "Друкувати модуль",

   "save-as-draft-title": "Зберегти як чернетку",
   "save-draft-description":
      "Щоб зберегти чернетку цього модуля, дайте їй назву, щоб ви могли переглянути її пізніше. Збережені чернетки зберігаються в нашій базі даних.",
   "save-draft-button": "Зберегти чернетку",

   "start-new-draft-button": "Почати нову чернетку",
   "my-saved-draft-title": "Моя збережена чернетка",
   "unsubmitted-drafts-description": "У вас є неподані чернетки для цього модуля.",
   "continue-draft-or-new-question": "Бажаєте продовжити з чернеткою чи почати нову?",
   "my-draft-label": "Моя чернетка",
   "no-drafts-found-text": "Чернеток не знайдено. Почніть нову чернетку.",

   "submit-module-confirm-description-part1":
      "Ви збираєтеся надіслати цей модуль. Щойно ви продовжите, ваші відповіді буде надіслано менеджеру проєкту для перевірки та затвердження.",
   "submit-module-confirm-description-part2":
      "Будь ласка, переконайтеся, що всі ваші відповіді точні, оскільки після надсилання ви не зможете внести жодних змін.",

   "approve-request-confirm-description":
      "Ви збираєтеся затвердити цей запит. Цю дію неможливо скасувати.",
   "feedback-required-validation": "Відгук обов'язковий",
   "reject-module-description-part1":
      "Будь ласка, надайте детальний відгук про те, чому цей модуль відхиляється.",
   "reject-module-description-part2":
      "Це слугуватиме орієнтиром для відповідального члена команди для внесення необхідних виправлень.",
   "why-rejecting-module-label": "Чому ви відхиляєте цей модуль?",
   "enter-rejection-reason-placeholder": "Будь ласка, вкажіть причину відхилення",

   "module-status-label": "Статус модуля:",
   "survey-status-published": "Опубліковано",
   "edit-module-details-tooltip": "Редагувати деталі модуля",
   "page-preparing-text": "Сторінка готується...",

   "add-section-to-module-tooltip": "Додати розділ до модуля",
   "add-inner-section-tooltip": "Додати внутрішній розділ",

   "question-type-section": "Розділ",
   "question-type-select-one": "Обрати один",
   "question-type-text": "Текст",
   "question-type-file-upload": "Завантаження файлу",
   "question-type-date": "Дата",
   "question-type-phone-number": "Номер телефону",
   "question-type-rating": "Оцінка",
   "question-type-ranking": "Рейтинг",
   "question-type-select-multiple": "Обрати кілька",
   "question-type-note": "Примітка",
   "question-type-date-time": "Дата і час",
   "question-type-time": "Час",
   "question-type-number": "Число",
   "question-type-acknowledge": "Підтвердження",
   "question-type-matrix": "Матриця",
   "type-section-label-placeholder": "Будь ласка, введіть назву розділу",
   "type-question-label-placeholder": "Будь ласка, введіть назву запитання",

   "option-placeholder": "Варіант",
   "enter-note-text-above": "Будь ласка, введіть текст примітки вище.",
   "calculate-question-coming-soon": "Питання розрахунку - незабаром...",
   "file-upload-caps-label": "ЗАВАНТАЖЕННЯ ФАЙЛУ",
   "items-to-be-ranked-label": "Елементи для ранжування",
   "text-question-type-label": "Тип питання: Текст",
   "question-displayed-as-table-text": "Це питання буде відображено у вигляді таблиці",
   "row-questions-title": "Питання рядків",
   "columns-questions-title": "Питання стовпців",
   "allow-numbers-range-only-text": "Дозволити числа лише з діапазону",
   "gps-question-coming-soon": "Питання GPS - незабаром...",
   "type-label-optional-placeholder": "Введіть назву (необов'язково)",
   "optional-placeholder": "Необов'язково",
   "reverse-answers-order-button": "Змінити порядок відповідей на зворотний",
   "type-answer-choice-placeholder": "Введіть варіант відповіді",
   "label-text": "Назва",
   "select-an-option-placeholder": "Оберіть варіант",
   "select-a-scale-placeholder": "Оберіть шкалу",
   "enter-bulk-action-placeholder": "Введіть масову дію",
   "to-divider-label": "До",
   "collect-date-info-text": "Зібрати інформацію про дату",
   "collect-time-info-text": "Зібрати інформацію про час",
   "collect-phone-number-info-text": "Зібрати інформацію про номер телефону",
   "type-a-question-placeholder": "Введіть питання",
   "min-label": "мін:",
   "max-label": "макс:",
   "max-options-chosen-text": "Максимальна кількість варіантів, які можна обрати",
   "all-options-label": "Усі",
   "answer-genius-label": "Геній відповідей",
   "add-choices-button": "Додати варіанти",
   "bulk-actions-label": "Масові дії",
   "enter-each-answer-choice-line-text": "Введіть кожен варіант відповіді в окремому рядку.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "Обов'язкова відповідь",
   "delete-question-confirm-title": "Ви впевнені, що хочете видалити це запитання?",
   "delete-section-confirm-title": "Ви впевнені, що хочете видалити цей розділ?",
   "this-action-cannot-be-undone-text": "Цю дію не можна скасувати",
   "yes-confirm-button": "Так",
   "no-confirm-button": "Ні",
   "add-new-question-button": "Додати нове запитання",
   "add-new-inner-section-button": "Додати новий внутрішній розділ",
   "add-new-section-button": "Додати новий розділ",

   // Skip logic (admin/survey v2)
   "show-logic-button": "Показати логіку",
   "display-condition-prefix-text": "Показати",
   "question-word-label": "Питання",
   "when-following-conditions-apply-text": "коли виконуються такі умови:",
   "add-another-condition-button": "Додати іншу умову",
   "should-match-all-the-criteria-placeholder-text": "має відповідати всім критеріям",
   "should-match-all-of-these-criteria-text": "має відповідати всім цим критеріям",
   "should-match-any-of-these-criteria-text": "має відповідати будь-якому з цих критеріїв",
   "operator-was-not-answered-label": "Не було дано відповіді",
   "operator-was-answered-label": "Було дано відповідь",
   "operator-equals-label": "Дорівнює (=)",
   "operator-not-equals-label": "Не дорівнює (!=)",
   "operator-greater-than-label": "Більше ніж (>)",
   "operator-less-than-label": "Менше ніж (<)",
   "operator-greater-than-or-equal-label": "Більше або дорівнює (>=)",
   "operator-less-than-or-equal-label": "Менше або дорівнює (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "Це поле обов'язкове",
   "type-your-answer-here-placeholder": "Введіть свою відповідь тут",
   "you-must-select-text": "Ви повинні вибрати",
   "you-must-enter-date-and-time-text": "Ви повинні вказати дату та час",
   "you-must-enter-a-number-text": "Ви повинні ввести число",
   "drag-drop-files-text": "Перетягніть файли сюди або натисніть, щоб вибрати файли",
   "uploaded-file-label": "Завантажений файл:",
   "you-must-upload-file-text": "Ви повинні завантажити файл",
   "all-rankings-must-be-selected-text": "Усі рейтинги мають бути вибрані",
   "please-specify-placeholder": "Будь ласка, вкажіть",
   "you-can-select-up-to-text": "Ви можете вибрати до",
   "choices-suffix-text": "варіантів.",
   "you-must-select-at-least-one-text": "Ви повинні вибрати принаймні один",
   "you-must-select-one-text": "Ви повинні вибрати один",
   "you-must-select-a-time-text": "Ви повинні вибрати час",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "Для цього модуля ще не було подано жодного подання.",
   "approval-successful-title": "Успішно",
   "submission-approved-successfully-text": "Подання успішно затверджено",
   "fetch-submission-answers-error": "Не вдалося отримати відповіді подання",
   "approve-without-review-button": "Затвердити без перевірки",
   "send-for-approval-button": "Надіслати на затвердження",
   "approve-module-pending-approver-description":
      "Ви збираєтеся затвердити цей модуль. Після продовження він буде надісланий затверджувачу для остаточної перевірки, перш ніж його статус буде позначено як",
   "approve-module-final-description-part1":
      "Ви збираєтеся надати остаточне затвердження цього модуля. Після продовження його статус буде позначено як",
   "approve-module-final-description-part2":
      "і його результати будуть доступні для аналізу. Цю дію не можна скасувати. Ви впевнені, що хочете продовжити?",
   "send-to-approver-for-review-label": "Надіслати затверджувачу для остаточної перевірки",
   "approver-review-recommended-hint": "Рекомендовано - пропуск цього кроку негайно завершує модуль.",
   "skipping-approver-review-warning-text":
      "Ви пропускаєте перевірку затверджувача. Цей модуль завершиться без повторної перевірки.",
   "enter-detailed-feedback-placeholder": "Будь ласка, введіть тут свій детальний відгук",

   // Approver management (admin/approver)
   "department-team-label": "Відділ/Команда",
   "enter-approver-name-placeholder": "Введіть ім'я затверджувача",
   "enter-approver-email-placeholder": "Введіть електронну пошту затверджувача",
   "enter-approver-department-placeholder": "Введіть відділ затверджувача",
   "approver-added-success-title": "Затверджувача успішно додано!",
   "approver-added-success-description": "Цього затверджувача тепер можна призначати на оцінювання.",
   "approver-updated-success-title": "Затверджувача успішно оновлено!",
   "approver-updated-success-description": "Дані цього затверджувача оновлено.",
   "approver-add-error-description":
      "Виникла проблема під час додавання цього затверджувача, спробуйте ще раз.",
   "approver-update-error-description":
      "Виникла проблема під час оновлення цього затверджувача, спробуйте ще раз.",
   "approver-delete-error-description":
      "Виникла проблема під час видалення цього затверджувача, спробуйте ще раз.",
   "approver-deleted-success-title": "Затверджувача успішно видалено!",
   "approver-deleted-success-description": "Цього затверджувача видалено.",
   "delete-approver-title": "Видалити затверджувача",
   "delete-approver-confirm-text": "Ви збираєтеся видалити цього затверджувача.",
   "add-approver-title": "Додати затверджувача",
   "edit-approver-title": "Редагувати затверджувача",
   "add-approver-button": "Додати затверджувача",
   "approvers-title": "Затверджувачі",
   "search-approver-by-name-placeholder": "Пошук затверджувача за іменем",
   "filter-approvers-by-department-placeholder": "Фільтрувати затверджувачів за відділом",

   // Approver submissions (approver-facing pages)
   "no-data-text": "Немає даних",
   "submitted-by-column": "Подано",
   "pending-modules-title": "Модулі в очікуванні",
   "approved-modules-title": "Затверджені модулі",
   "rejected-modules-title": "Відхилені модулі",
   "filter-tasks-by-submission-date-placeholder": "Фільтрувати завдання за датою подання",
   "module-approvals-title": "Затвердження модулів",
   "pending-modules-review-description":
      "Це список модулів, що очікують вашого розгляду. Щоб продовжити, натисніть на кожен модуль, де ви зможете прийняти або відхилити його.",
   "the-approver-label": "затверджувач",
   "approver-label": "Затверджувач",
   "select-an-approver-placeholder": "Оберіть затверджувача",
   "go-to-revise-module-button": "Перейти до перегляду модуля",
   "rejected-module-information-title": "Інформація про відхилений модуль",
   "feedback-from-label-prefix": "Відгук від",
   "the-project-manager-label": "керівник проєкту",
   "awaiting-approver-status": "Очікує затверджувача",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "Назва модуля",
   "enter-module-title-placeholder": "Введіть назву модуля",
   "module-description-label": "Опис модуля",
   "assigned-assessment-label": "Призначена оцінка",
   "survey-updated-success-title": "Опитування успішно оновлено!",
   "module-updated-success-description": "Цей модуль було правильно оновлено.",
   "edit-module-error-description": "Виникла проблема під час редагування цього модуля, спробуйте ще раз.",
   "form-builder-tab-label": "Конструктор форм",
   "logic-builder-tab-label": "Конструктор логіки",
   "translate-questions-tab-label": "Перекласти запитання",
   "score-questions-tab-label": "Оцінити запитання",
   "stay-here-button": "Залишитися тут",
   "change-tab-button": "Змінити вкладку",
   "unsaved-progress-title": "Незбережений прогрес",
   "unsaved-changes-tab-text": "У вас є незбережені зміни на цій вкладці.",
   "confirm-proceed-without-saving-part1": "Ви впевнені, що хочете продовжити",
   "confirm-proceed-without-saving-part2": "без збереження прогресу?",
   "module-status-changed-success-title": "Статус модуля успішно змінено!",
   "module-status-changed-success-description": "Статус цього модуля було правильно змінено.",
   "problem-occurred-title": "Виникла проблема!",
   "change-status-error-description":
      "Виникла проблема під час зміни статусу цього модуля, спробуйте ще раз.",
   "publish-module-button": "Опублікувати модуль",
   "change-status-to-editing-button": "Змінити статус на Редагування",
   "changes-saved-success-description": "Зміни успішно збережено",
   "save-progress-button": "Зберегти прогрес",
   "skip-logic-saved-success-description": "Логіку пропуску успішно додано",
   "score-points-saved-success-description": "Бали успішно додано",
   "total-module-score-label": "Загальний бал модуля:",
   "points-suffix": "балів",
   "answers-column-label": "Відповіді",
   "score-column-label": "Оцінка",
   "input-score-placeholder": "Введіть оцінку",
   "max-score-label": "Максимальний бал:",
   "date-answer-label": "Відповідь-дата",
   "time-answer-label": "Відповідь-час",
   "answer-keywords-label": "Ключові слова відповіді",
   "section-score-label": "Бал розділу:",
   "number-range-hint-prefix": "Діапазон для цього запитання",
   "number-range-hint-value": "від 1 до 50",
   "number-range-hint-suffix": ". Будь ласка, виберіть правильні варіанти відповідей для оцінювання:",
   "select-right-answer-choices-placeholder": "Виберіть правильні варіанти відповідей",
   "single-number-option-label": "Одне число",
   "range-option-label": "Діапазон",
   "enter-range-correct-answers-label": "Введіть діапазон правильних відповідей",
   "to-connector-label": "до",
   "enter-correct-number-label": "Введіть правильне число",
   "input-number-placeholder": "Введіть число",
   "ranking-score-instructions-text":
      "Будь ласка, розташуйте варіанти у правильному порядку, потім присвойте бал кожному",
   "input-phone-number-placeholder": "Введіть номер телефону",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "Основний модуль",
   "main-module-description-text": "Це запитання з вашого основного модуля",
   "default-language-placeholder": "Мова за замовчуванням",
   "translate-module-title": "Перекласти модуль",
   "write-translation-here-text": "Напишіть переклад кожного запитання тут",
   "translate-to-label": "Перекласти на",
   "select-a-language-placeholder": "--Виберіть мову--",
   "select-language-first-error": "Будь ласка, спочатку виберіть мову",
   "translation-saved-success-description": "Переклад успішно збережено",
   "save-translation-button": "Зберегти переклад",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "Модуль є обов'язковим",
   "at-least-one-section-required-validation": "Потрібен щонайменше один розділ",
   "resource-type-required-validation": "Тип ресурсу є обов'язковим",
   "at-least-one-attachment-required-validation": "Потрібен щонайменше один додаток",
   "description-required-validation": "Опис є обов'язковим",
   "tagged-topics-required-validation": "Позначені теми є обов'язковими",
   "invalid-url-format-validation": "Недійсний формат URL",
   "link-url-required-validation": "URL-адреса посилання є обов'язковою",
   "agree-to-terms-required-validation": "Ви повинні погодитися з умовами",
   "section-required-validation": "Розділ є обов'язковим",
   "resources-added-success-title": "Ресурси успішно додано!",
   "resources-added-success-description": "Ці ресурси створено та додано до вашої бази даних.",
   "upload-resource-matching-type-error": "Будь ласка, завантажте ресурс, що відповідає вибраному типу.",
   "resources-updated-success-title": "Ресурси успішно оновлено!",
   "resources-updated-success-description": "Ці ресурси успішно оновлено.",
   "add-new-resource-title": "Новий ресурс",
   "edit-resource-title": "Редагувати ресурс",
   "resource-upload-shared-repository-notice":
      "Будь-який ресурс, який ви завантажите на платформу, буде опубліковано у спільному репозиторії KAPorg, що зробить його доступним для завантаження та обміну іншими користувачами, сприяючи підтримці спільноти.",
   "select-module-link-resource-label": "Виберіть модуль, до якого потрібно прив'язати цей ресурс",
   "all-modules-in-assessment-placeholder": "Усі модулі цієї оцінки",
   "select-section-link-resource-label":
      "Виберіть розділ модуля, до якого потрібно прив'язати цей ресурс",
   "all-sections-of-module-placeholder": "Усі розділи модуля",
   "resource-information-title": "Інформація про ресурс",
   "select-resource-type-label": "Виберіть тип ресурсу",
   "before-upload-select-type-hint": "Перед завантаженням ресурсу потрібно вибрати його тип",
   "paste-link-here-label": "Вставте посилання тут",
   "enter-link-url-placeholder": "Введіть URL-адресу посилання",
   "upload-file-here-label": "Завантажте файл тут",
   "drag-drop-file-here-prefix": "Перетягніть файл сюди або",
   "click-to-select-file-text": "натисніть, щоб вибрати файл",
   "max-file-size-text": "Максимальний розмір файлу: 20МБ",
   "enter-resource-description-label": "Введіть опис ресурсу",
   "tagged-topics-label": "Позначені теми",
   "enter-tagged-topics-placeholder": "Введіть теми, з якими можна пов'язати цей ресурс",
   "upload-rights-confirmation-text":
      "Завантажуючи цей матеріал, я підтверджую, що маю необхідні права та дозволи для цього.",
   "add-resource-button": "Додати ресурс",
   "expert-name-column": "Ім'я експерта",
   "operating-countries-column": "Країни діяльності",
   "years-of-experience-column": "Роки досвіду",
   "expert-cv-column": "Резюме експерта",
   "areas-of-expertise-column": "Сфери експертизи",
   "assign-experts-to-assessment-title": "Призначити експертів для цієї оцінки",
   "select-expert-assign-assessment-text": "Виберіть експерта, якого потрібно призначити для цієї оцінки.",
   "search-resource-by-name-placeholder": "Пошук ресурсу за назвою",
   "assign-expert-to-assessment-button": "Призначити експерта для цієї оцінки",
   "expert-assigned-success-title": "Експерта успішно призначено!",
   "expert-assigned-success-description": "Цього експерта призначено та додано до вашої бази даних плану дій.",
   "assign-expert-error-description":
      "Виникла проблема під час призначення цього експерта до вашого плану дій, спробуйте ще раз.",
   "expert-removed-success-title": "Експерта успішно видалено!",
   "expert-removed-success-description": "Цього експерта видалено з вашої бази даних плану дій.",
   "remove-expert-from-assessment-button": "Видалити експерта з цієї оцінки",
   "email-label-colon": "Електронна пошта:",
   "description-label-colon": "Опис:",
   "no-description-available-text": "Опис відсутній",
   "no-expertise-listed-text": "Експертиза не вказана",
   "field-of-study-label": "Галузь навчання",
   "no-field-of-study-listed-text": "Галузь навчання не вказана",
   "no-operating-countries-listed-text": "Країни діяльності не вказані",
   "languages-label": "Мови",
   "no-languages-listed-text": "Мови не вказані",
   "linkedin-profile-label": "Профіль LinkedIn",
   "no-linkedin-profile-text": "Профіль LinkedIn не надано",
   "delete-collection-title": "Видалити колекцію",
   "delete-collection-confirm-text": "Ви збираєтеся видалити цю колекцію. Цю дію не можна скасувати.",
   "delete-resource-title": "Видалити ресурс",
   "delete-resource-confirm-text": "Ви збираєтеся видалити цей ресурс. Цю дію не можна скасувати.",
   "collection-deleted-success-title": "Колекцію успішно видалено!",
   "collection-deleted-success-description": "Цю колекцію успішно видалено з вашої бази даних.",
   "resource-deleted-success-title": "Ресурс успішно видалено!",
   "resource-deleted-success-description": "Цей ресурс успішно видалено з вашої бази даних.",
   "delete-resource-error-description": "Виникла проблема під час видалення цього ресурсу, спробуйте ще раз.",
   "resource-preview-title": "Попередній перегляд ресурсу",
   "document-type-label": "Документ",
   "video-type-label": "Відео",
   "slide-type-label": "Слайд",
   "tags-and-categories-label": "Теги та категорії",
   "upload-date-label": "Дата завантаження",
   "description-label": "Опис",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "Статус:",
   "assign-to-label-colon": "Призначено:",
   "deadline-label-colon": "Термін:",
   "resources-attached-section-text": "Ресурси, додані до цього розділу",
   "resource-link-label-colon": "Це посилання на ресурс:",
   "task-title-required-validation": "Назва завдання є обов'язковою",
   "deadline-required-validation": "Термін є обов'язковим",
   "create-new-task-title": "Створити нове завдання",
   "edit-task-title": "Редагувати завдання",
   "task-title-label": "Назва завдання",
   "task-title-example-placeholder": "Як часто ви проводите навчання своїх співробітників?",
   "enter-task-instruction-placeholder":
      "Введіть примітку або інструкцію, яка допоможе призначеній особі виконати завдання",
   "assign-task-to-label": "Призначити завдання",
   "select-member-assign-task-placeholder": "Виберіть учасника для призначення цього завдання",
   "cant-find-member-assign-task-text": "Не можете знайти учасника для призначення завдання?",
   "add-in-organization-management-text": "Додайте його в управлінні організацією",
   "upload-files-complete-task-label": "Завантажте файли, необхідні для виконання цього завдання",
   "can-add-up-to-3-resources-text": "Ви можете додати до 3 ресурсів",
   "deadline-label": "Термін",
   "resource-link-optional-label": "Ваш ресурс є посиланням? Будь ласка, введіть його тут",
   "enter-resource-link-placeholder": "Введіть посилання на ваш ресурс",
   "assign-task-title": "Призначити завдання",
   "assign-task-at-least-one-member-validation": "Призначте завдання щонайменше одному учаснику",
   "deadline-valid-date-validation": "Термін повинен бути дійсною датою",
   "select-deadline-placeholder": "Виберіть термін",
   "task-added-assigned-success-title": "Завдання успішно додано та призначено!",
   "task-added-assigned-success-description":
      "Це завдання успішно призначено, учасника, якого ви вибрали, буде повідомлено про це.",
   "assign-task-error-description": "Виникла проблема під час призначення цього завдання, спробуйте ще раз.",
   "select-status-title": "Виберіть статус",
   "task-updated-success-title": "Завдання успішно оновлено!",
   "task-updated-success-description": "Це завдання успішно оновлено у вашій базі даних.",
   "update-task-error-description": "Виникла проблема під час оновлення цього завдання, спробуйте ще раз.",
   "task-deleted-success-title": "Завдання успішно видалено!",
   "task-deleted-success-description": "Це завдання успішно видалено з вашої бази даних.",
   "delete-task-error-description": "Виникла проблема під час видалення цього завдання, спробуйте ще раз.",
   "delete-task-title": "Видалити завдання",
   "delete-task-confirm-text": "Ви збираєтеся видалити це завдання. Цю дію не можна скасувати.",
   "rounds-filter-label": "Раунди",
   "managers-filter-label": "Менеджери",
   "generate-report-button": "Створити звіт",
   "generate-report-title": "Створити звіт",
   "choose-sections-report-text": "Виберіть розділи, які потрібно включити до звіту.",
   "include-module-breakdown-label": "Включити розбивку за модулями",
   "of-label": "з",
   "sections-selected-suffix": "розділів вибрано",
   "generate-button": "Створити",
   "report-preview-title": "Попередній перегляд звіту",
   "edit-sections-button": "Редагувати розділи",
   "assessment-report-eyebrow-text": "Звіт про оцінювання",
   "no-sections-data-selected-text": "Немає вибраних розділів із даними.",
   "assessment-report-pdf-heading": "ЗВІТ ПРО ОЦІНЮВАННЯ",
   "exported-on-label": "Експортовано",
   "page-word": "Сторінка",
   "add-review-note-title": "Додати примітку огляду",
   "edit-review-note-title": "Редагувати примітку огляду",
   "note-title-required-validation": "Будь ласка, введіть назву примітки",
   "enter-note-title-placeholder": "Введіть назву примітки",
   "round-covered-label": "Охоплений раунд",
   "select-option-required-validation": "Будь ласка, виберіть варіант",
   "note-required-validation": "Будь ласка, введіть свої примітки",
   "summarize-progress-placeholder": "Підсумуйте основний прогрес, рішення чи проблеми.",
   "add-note-button": "Додати примітку",
   "staff-members-fetch-error":
      "Виникла проблема під час отримання співробітників, будь ласка, оновіть сторінку.",
   "task-priority-fetch-error":
      "Виникла проблема під час отримання пріоритету завдання, будь ласка, оновіть сторінку.",
   "select-section-add-task-error": "Будь ласка, виберіть розділ, щоб додати це завдання.",
   "add-task-error-description": "Виникла проблема під час додавання цього завдання, спробуйте ще раз.",
   "add-new-task-title": "Додати нове завдання",
   "task-name-label": "Назва завдання",
   "task-name-required-validation": "Будь ласка, введіть назву завдання",
   "enter-task-name-placeholder": "Введіть назву завдання",
   "linked-questions-label": "Пов'язані запитання",
   "select-questions-required-validation": "Будь ласка, виберіть запитання",
   "linked-questions-helper-text": "Виберіть запитання, які це завдання має покращити",
   "select-questions-placeholder": "Виберіть запитання",
   "task-description-required-validation": "Будь ласка, введіть опис",
   "enter-task-description-placeholder": "Введіть опис завдання",
   "select-member-required-validation": "Будь ласка, виберіть учасника",
   "select-deadline-required-validation": "Будь ласка, виберіть термін",
   "priority-label": "Пріоритет",
   "select-priority-required-validation": "Будь ласка, виберіть пріоритет",
   "select-priority-placeholder": "Виберіть пріоритет",
   "resources-label": "Ресурси",
   "select-resources-placeholder": "Виберіть ресурси, пов'язані з цим завданням",
   "select-resources-required-validation": "Будь ласка, виберіть ресурси",
   "search-resource-placeholder": "Пошук ресурсу",
   "browse-resources-library-text": "Перегляд бібліотеки ресурсів",
   "add-task-button": "Додати завдання",
   "confirm-selection-button": "Підтвердити вибір",
   "resource-library-title": "Бібліотека ресурсів",
   "collections-tab-label": "Колекції",
   "workspace-breadcrumb-label": "Робочий простір",
   "resources-breadcrumb-label": "Ресурси",
   "results-breadcrumb-label": "Результати",
   "action-plan-breadcrumb-label": "План дій",
   "respondents-count-label": "респондентів",
   "of-word": "з",
   "copy-tasks-title": "Копіювати завдання",
   "copy-tasks-description-text":
      "Усі завдання з попереднього раунду будуть скопійовані, щоб ваш план дій залишався повним з часом.",
   "previous-round-label": "Попередній раунд:",
   "tasks-copied-label": "Скопійовано завдань",
   "task-statistics-fetch-error":
      "Виникла проблема під час завантаження статистики завдань, спробуйте ще раз.",
   "delete-note-confirm-text":
      "Ви збираєтеся видалити цю примітку огляду. Цю дію не можна скасувати.",
   "delete-view-title": "Видалити вигляд",
   "delete-view-confirm-text": "Ви збираєтеся видалити цей вигляд. Цю дію не можна скасувати.",
   "rename-view-title": "Перейменувати вигляд",
   "save-button": "Зберегти",
   "select-a-resource-title": "Виберіть ресурс",
   "set-a-reminder-title": "Встановити нагадування",
   "reminder-description-text":
      "Виберіть, коли ви хочете отримати нагадування про додавання або оновлення записів прогресу вашої команди.",
   "reminder-type-label": "Тип нагадування",
   "select-reminder-type-required-validation": "Будь ласка, виберіть тип нагадування",
   "select-day-required-validation": "Будь ласка, виберіть день",
   "select-a-day-placeholder": "Виберіть день",
   "reminder-repeat-prefix-text":
      "Це буде дата вашого першого нагадування. Наступні нагадування повторюватимуться кожен(у)",
   "repeat-interval-week": "тиждень",
   "repeat-interval-2-weeks": "2 тижні",
   "repeat-interval-month": "місяць",
   "repeat-interval-3-months": "3 місяці",
   "repeat-interval-year": "рік",
   "reminder-repeat-suffix-text": "у той самий день.",
   "next-reminder-date-label": "Дата наступного нагадування:",
   "save-reminder-button": "Зберегти нагадування",
   "my-workspaces-tab": "Мої робочі простори",
   "all-workspaces-tab": "Усі робочі простори",
   "fetch-workspaces-error-description":
      "Виникла проблема під час отримання робочих просторів, будь ласка, спробуйте ще раз.",
   "archived-workspaces-title": "Архівовані робочі простори",
   "deleted-workspaces-button": "Видалені робочі простори",
   "new-workspace-button": "Новий робочий простір",
   "remove-action": "Прибрати",
   "workspace-name-label": "Назва робочого простору",
   "enter-workspace-name-placeholder": "Введіть назву вашого робочого простору",
   "workspace-description-label": "Опис робочого простору",
   "enter-workspace-description-placeholder": "Введіть опис робочого простору",
   "workspace-countries-label": "Країни робочого простору",
   "select-a-country-placeholder": "Виберіть країну",
   "workspace-assessment-label": "Оцінювання робочого простору",
   "select-default-assessment-survey-placeholder": "Виберіть стандартне оцінювання для опитування",
   "select-default-assessment-module-placeholder": "Виберіть стандартне оцінювання для модуля",
   "workspace-duplicate-name-validation": "Цей робочий простір вже існує. Спробуйте іншу назву.",
   "workspace-created-success-title": "Робочий простір успішно створено!",
   "workspace-created-success-description":
      "Новий робочий простір було створено та додано до вашої бази даних",
   "create-workspace-error-description":
      "Виникла проблема під час створення цього робочого простору, будь ласка, спробуйте ще раз.",
   "add-new-workspace-title": "Додати новий робочий простір",
   "workspace-updated-success-title": "Робочий простір успішно оновлено!",
   "workspace-updated-success-description": "Цей робочий простір успішно оновлено.",
   "update-workspace-error-description":
      "Виникла проблема під час оновлення цього робочого простору, будь ласка, спробуйте ще раз.",
   "edit-workspace-title": "Редагувати робочий простір",
   "at-least-one-assessment-required-validation": "Потрібне щонайменше одне оцінювання",
   "workspace-archived-success-title": "Робочий простір успішно архівовано!",
   "workspace-archived-success-description": "Цей робочий простір успішно архівовано.",
   "archive-workspace-error-description":
      "Виникла проблема під час архівування цього робочого простору, будь ласка, спробуйте ще раз.",
   "archive-workspace-title": "Архівувати робочий простір",
   "archive-workspace-confirm-text": "Ви збираєтеся архівувати цей робочий простір.",
   "workspace-deleted-success-title": "Робочий простір успішно видалено!",
   "workspace-deleted-success-description": "Цей робочий простір успішно видалено.",
   "delete-workspace-error-description":
      "Виникла проблема під час видалення цього робочого простору, будь ласка, спробуйте ще раз.",
   "delete-workspace-title": "Видалити робочий простір",
   "delete-workspace-confirm-text": "Ви збираєтеся видалити цей робочий простір.",
   "workspace-restored-success-title": "Робочий простір успішно відновлено!",
   "restore-workspace-error-description":
      "Виникла проблема під час відновлення цього робочого простору, будь ласка, спробуйте ще раз.",
   "workspace-deleted-permanently-success-description":
      "Цей робочий простір успішно видалено з вашої бази даних.",
   "restore-assessment-error-description":
      "Виникла проблема під час відновлення цього оцінювання, будь ласка, спробуйте ще раз.",
   "restore-workspaces-button": "Відновити робочі простори",
   "delete-workspace-permanently-title": "Видалити робочий простір остаточно",
   "delete-workspace-permanently-confirm-text":
      "Ви збираєтеся остаточно видалити цей робочий простір. Цю дію не можна скасувати.",
   "workspaces-unarchived-success-title": "Робочі простори успішно розархівовано!",
   "workspaces-unarchived-success-description":
      "Ці робочі простори було розархівовано та додано до вашої бази даних.",
   "unarchive-workspace-error-description":
      "Виникла проблема під час розархівування цього робочого простору, будь ласка, спробуйте ще раз.",
   "workspaces-deleted-success-title": "Робочі простори успішно видалено!",
   "workspaces-deleted-success-description": "Ці робочі простори було видалено з вашої бази даних.",
   "deleted-workspaces-list-title": "Список видалених робочих просторів",
   "deleted-workspaces-retention-text":
      "Тут ви можете переглянути та відновити видалені робочі простори. Будь-який робочий простір, який не буде відновлено протягом 60 днів, буде остаточно видалено.",
   "request-canceled-success-title": "Запит успішно скасовано!",
   "request-canceled-success-description": "Ваш запит було скасовано.",
   "cancel-request-error-description":
      "Виникла проблема під час скасування цього запиту, будь ласка, спробуйте ще раз.",
   "cancel-request-button": "Скасувати запит",
   "send-request-success-description":
      "Ваш запит було надіслано адміністратору. Щойно на запит буде надано відповідь, ви отримаєте електронний лист.",
   "send-request-error-description":
      "Виникла проблема під час надсилання вашого запиту, будь ласка, спробуйте ще раз.",
   "no-workspaces-here-title": "Тут немає робочих просторів!",
   "request-part-workspace-description":
      "Але не турбуйтеся, ви можете подати запит на приєднання до робочого простору в розділі «Усі робочі простори».",
   "go-to-all-workspaces-button": "Перейти до всіх робочих просторів",
   "create-workspaces-tagline-text":
      "Створюйте робочі простори, розроблені для сприяння зростанню та оптимізації організацій.",
   "export-workspaces-button": "Експортувати робочі простори",
   "all-workspaces-consultant-heading": "Усі робочі простори",
   "assess-partners-consultant-description":
      "Почніть оцінювати місцевих партнерів/громадські організації та надайте їм детальний звіт про їхню поточну ефективність.",
   "access-workspace-organization-text": "Увійдіть у робочий простір і почніть отримувати доступ до вашої організації.",
   "no-workspace-created-yet-description":
      "Здається, ви ще не створили жодного робочого простору. Але не турбуйтеся, ви можете створити його тут.",
   "untitled-label": "Без назви",
   "no-section-label": "Без розділу",
   "swot-analysis-title": "SWOT-аналіз",
   "swot-analysis-subtitle-text": "Проаналізуйте сильні сторони, слабкі сторони, можливості та загрози",
   "related-module-label": "Пов'язаний модуль",
   "select-module-placeholder": "Виберіть модуль",
   "enter-analysis-description-placeholder": "Введіть опис аналізу",
   "swot-strengths-title": "Сильні сторони",
   "swot-weaknesses-title": "Слабкі сторони",
   "swot-opportunities-title": "Можливості",
   "swot-threats-title": "Загрози",
   "related-sections-label": "Пов'язані розділи",
   "select-sections-placeholder": "Виберіть розділи",
   "analysis-label": "Аналіз",
   "describe-strengths-placeholder": "Опишіть сильні сторони",
   "describe-weaknesses-placeholder": "Опишіть слабкі сторони",
   "describe-opportunities-placeholder": "Опишіть можливості",
   "describe-threats-placeholder": "Опишіть загрози",
   "add-analysis-button": "Додати аналіз",
   "scores-label": "Оцінки",
   "guided-assessment-label": "Керована оцінка",
   "self-assessment-label": "Самооцінка",
   "highlights-title": "Основні моменти",
   "highlights-subtitle-text":
      "Виділіть основні висновки та надайте рекомендації на основі результатів",
   "choose-chart-analyze-label": "Виберіть діаграму, яку хочете проаналізувати",
   "select-chart-analyze-text": "Виберіть діаграму, яку хочете проаналізувати",
   "change-button": "Змінити",
   "select-a-module-first-placeholder": "Спочатку виберіть модуль",
   "add-comparison-label": "Додати порівняння",
   "insight-label": "Висновок",
   "max-400-characters-validation": "Максимум 400 символів",
   "describe-key-points-placeholder":
      "Опишіть основні моменти, які хочете виділити на цій діаграмі...",
   "select-chart-to-analyze-title": "Виберіть діаграму для аналізу",
   "choose-chart-from-list-text": "Виберіть одну з доступних діаграм зі списку для аналізу.",
   "report-title": "Звіт",
   "upload-report-insights-text":
      "Завантажте свій звіт, щоб він став частиною висновків для цього оцінювання.",
   "upload-file-here-label": "Завантажте файл тут",
   "current-file-text": "Поточний файл",
   "remove-file-aria-label": "Видалити файл",
   "doc-pdf-pptx-text": "DOC, PDF або PPTX",
   "only-doc-pdf-pptx-error": "Дозволені лише файли DOC, PDF або PPTX.",
   "file-must-be-smaller-than-prefix": "Файл повинен бути меншим за",
   "missing-assessment-org-warning": "Відсутні дані про оцінювання або організацію.",
   "upload-report-file-warning": "Будь ласка, завантажте файл звіту.",
   "title-required-validation": "Назва обов'язкова",
   "ticket-type-required-validation": "Тип заявки обов'язковий",
   "message-required-validation": "Повідомлення обов'язкове",
   "ticket-added-success-title": "Заявку успішно додано!",
   "ticket-added-success-description":
      "Цю заявку успішно додано до бази даних історії ваших заявок, найближчим часом хтось відповість на ваш запит.",
   "add-ticket-error-description": "Виникла проблема під час додавання цієї заявки, спробуйте ще раз.",
   "upload-jpg-png-gif-webp-error": "Будь ласка, завантажуйте лише файли JPG, PNG, GIF або WEBP.",
   "add-new-ticket-title": "Додати нову заявку",
   "ticket-type-label": "Тип заявки",
   "select-ticket-type-placeholder": "Виберіть тип заявки",
   "summary-label": "Стислий опис",
   "enter-title-placeholder": "Введіть назву",
   "describe-problem-detail-label": "Детально опишіть проблему",
   "type-something-placeholder": "Напишіть щось тут",
   "attach-evidence-label": "Додайте будь-які доказательства, які вважаєте важливими",
   "jpg-png-gif-webp-text": "JPG, PNG, GIF та WEBP",
   "add-ticket-button": "Додати заявку",
   "tickets-deleted-success-title": "Вибрані заявки успішно видалено!",
   "tickets-deleted-success-description": "Ці вибрані заявки успішно видалено з бази даних",
   "delete-tickets-error-description":
      "Виникла проблема під час видалення цих вибраних заявок, спробуйте ще раз.",
   "delete-selected-tickets-title": "Видалити вибрані заявки",
   "delete-selected-tickets-confirm-text": "Ви збираєтеся видалити ці вибрані заявки.",
   "collection-updated-success-title": "Колекцію успішно оновлено!",
   "collection-updated-success-description": "Цю колекцію правильно оновлено.",
   "update-collection-error-description": "Виникла проблема під час оновлення цієї колекції, спробуйте ще раз.",
   "collection-added-success-title": "Колекцію успішно додано!",
   "collection-added-success-description": "Цю колекцію створено та додано до вашої бази даних.",
   "add-collection-error-description": "Виникла проблема під час додавання цієї колекції, спробуйте ще раз.",
   "edit-collection-title": "Редагувати колекцію",
   "add-new-collection-title": "Додати нову колекцію",
   "new-collection-button-label": "Нова колекція",
   "name-collection-label": "Назва колекції",
   "enter-collection-name-placeholder": "Введіть назву колекції",
   "enter-collection-description-placeholder": "Введіть опис колекції",
   "select-the-assessment-label": "Виберіть оцінювання",
   "select-resources-collection-placeholder": "Виберіть ресурси, пов'язані з цією колекцією",
   "see-more-text": "Побачити більше",
   "make-collection-public-label": "Зробити цю колекцію публічною та видимою для всіх",
   "add-collection-button": "Додати колекцію",
   "global-status": "Загальний",
   "owner-colon-label": "Власник:",
   "resources-colon-label": "Ресурси:",
   "resource-added-collection-success-title": "Ресурс додано до колекції!",
   "resource-added-collection-success-description": "Цей ресурс успішно додано до колекції.",
   "add-resource-collection-error-description":
      "Виникла проблема під час додавання цього ресурсу до колекції, спробуйте ще раз.",
   "add-to-collection-title": "Додати до колекції",
   "resource-updated-success-title": "Ресурс успішно оновлено!",
   "resource-updated-success-description": "Цей ресурс правильно оновлено. Створено нову версію",
   "update-resource-error-description": "Виникла проблема під час оновлення цього ресурсу, спробуйте ще раз.",
   "resource-added-success-title": "Ресурс успішно додано!",
   "resource-added-success-description": "Цей ресурс створено та додано до вашої бази даних.",
   "add-resource-error-description": "Виникла проблема під час додавання цього ресурсу, спробуйте ще раз.",
   "edit-resource-title": "Редагувати ресурс",
   "select-resource-type-label": "Виберіть тип ресурсу",
   "select-resource-type-required-validation": "Будь ласка, виберіть тип ресурсу",
   "video-placeholder-text": "Відео",
   "select-type-before-upload-text": "Перед завантаженням ресурсу потрібно вибрати його тип",
   "enter-resource-link-label": "Будь ласка, введіть посилання на ресурс тут",
   "valid-url-required-validation": "Будь ласка, введіть дійсну URL-адресу",
   "enter-resource-link-placeholder": "Введіть посилання на ваш ресурс",
   "select-a-file-required-validation": "Будь ласка, виберіть файл",
   "click-to-select-files-text": "натисніть, щоб вибрати файли",
   "resource-version-colon-label": "Версія ресурсу:",
   "make-resource-private-label": "Зробити цей ресурс приватним",
   "resource-name-label": "Назва ресурсу",
   "enter-resource-name-placeholder": "Введіть назву ресурсу",
   "tags-label": "Теги",
   "enter-resource-tags-placeholder": "Введіть теми, з якими може бути пов'язаний цей ресурс",
   "select-module-label": "Виберіть модуль",
   "select-section-label": "Виберіть розділ",
   "upload-consent-text":
      "Будь-який завантажений вами ресурс зберігатиметься в репозиторії KAPorg відповідно до обраного вами рівня видимості, роблячи його доступним для вибраної аудиторії. Продовжуючи, ви підтверджуєте, що маєте необхідні права та дозволи для завантаження цього матеріалу.",
   "add-resource-button": "Додати ресурс",
   "file-label": "Файл",
   "views-suffix": "Перегляди",
   "rating-suffix": "Оцінка",
   "owner-label": "Власник",
   "visibility-label": "Видимість",
   "linked-to-label": "Пов'язано з",
   "last-update-date-label": "Дата останнього оновлення",
   "resource-version-label": "Версія ресурсу",
   "targets-updated-success-title": "Цілі успішно оновлено!",
   "targets-updated-success-description": "Усі зміни успішно збережено.",
   "save-targets-error-description": "Виникла проблема під час збереження всіх змін, спробуйте ще раз.",
   "current-target-label": "Поточна ціль:",
   "no-active-rounds-text": "Немає активних раундів",
   "no-target-set-yet-text": "Ціль ще не встановлено",
   "no-assessments-found-text": "Оцінювань не знайдено",
   "no-modules-yet-title": "Ще немає модулів",
   "no-modules-assigned-description":
      "Цьому оцінюванню не призначено жодного модуля. Вони з'являться тут після додавання.",
   "enter-target-placeholder": "Введіть ціль",
   "ticket-history-title": "Історія заявок",
   "help-desk-title": "Служба підтримки",
   "delete-selected-rows-text": "Видалити вибрані рядки",
   "add-new-ticket-text": "Нова заявка",
   "subject-column": "Тема",
   "creation-date-column": "Дата створення",
   "organization-column": "Організація",
   "last-response-column": "Остання відповідь",
   "ticket-preview-title": "Перегляд заявки",
   "ticket-status-closed": "Закрито",
   "ticket-summary-title": "Підсумок заявки",
   "user-email-label": "Електронна пошта користувача",
   "ticket-subject-label": "Тема заявки",
   "mark-as-resolved-button": "Закрити заявку",
   "mark-ticket-resolved-title": "Закрити цю заявку?",
   "mark-ticket-resolved-confirm-text": "Ви впевнені, що хочете закрити цю заявку? Організація все ще може відповісти, якщо їй потрібна додаткова допомога.",
   "ticket-resolved-success-title": "Заявку закрито",
   "ticket-resolved-success-description": "Заявку було закрито.",
   "resolve-ticket-error-description": "Під час закриття заявки виникла помилка. Будь ласка, спробуйте ще раз.",
   "type-your-message-placeholder": "Введіть ваше повідомлення тут...",
   "filter-tickets-by-type-placeholder": "Фільтрувати за типом",
   "filter-tickets-by-status-placeholder": "Фільтрувати за статусом",
   "summary-results-title": "Підсумкові результати",
   "graphs-view-tab": "Перегляд графіків",
   "table-view-tab": "Перегляд таблиці",
   "expert-insights-tab": "Висновки експертів",
   "no-dashboard-results-yet-title": "Ця панель ще не має результатів",
   "results-appear-here-description": "Коли дані стануть доступними, ваші результати з'являться тут.",
   "submission-round-column": "Раунд подання",
   "submission-label-column": "Позначка подання",
   "select-module-first-text": "Будь ласка, спочатку виберіть модуль.",
   "select-at-least-one-submission-round-text": "Будь ласка, виберіть щонайменше один раунд подання.",
   "unable-detect-organization-text": "Не вдалося визначити вашу організацію. Будь ласка, увійдіть знову.",
   "download-table-label": "Завантажити таблицю",
   "score-overview-title": "Огляд оцінки",
   "toggle-score-overview-aria-label": "Перемкнути огляд оцінки",
   "visualizations-title": "Візуалізації",
   "search-a-graph-placeholder": "Пошук діаграми",
   "select-view-placeholder": "Виберіть перегляд",
   "save-view-button": "Зберегти перегляд",
   "save-dashboard-button": "Зберегти панель",
   "edit-dashboard-button": "Редагувати панель",
   "download-dashboard-label": "Завантажити панель",
   "round-label": "Раунд",
   "manager-label": "Менеджер",
   "select-an-organization-placeholder": "Виберіть організацію",
   "select-all-option": "Вибрати все",
   "all-placeholder": "Усі",
   "score-percent-label": "Оцінка (%)",
   "task-completion-percent-label": "Виконання завдань (%)",
   "task-status-percent-label": "Статус завдань (%)",
   "value-label": "Значення",
   "first-round-label": "Перший раунд",
   "second-round-label": "Другий раунд",
   "improvement-percent-label": "Покращення %",
   "result-label": "Результат",
   "current-label": "Поточний",
   "target-word": "Ціль",
   "overall-score-label": "Загальна оцінка",
   "of-tasks-completed-label": "виконаних завдань",
   "leading-label": "Лідери",
   "developing-label": "Розвиваються",
   "lagging-label": "Відстають",
   "section-word": "Розділ",
   "task-completion-label": "Виконання завдань",
   "indicator-word": "Показник",
   "progress-word": "Прогрес",
   "current-round-label": "Поточний раунд:",
   "change-label": "Зміна:",
   "improvement-label": "Покращення",
   "task-count-label": "Кількість завдань",
   "assessment-results-per-module-title": "Результати оцінювання за модулем",
   "assessment-results-per-section-title": "Результати оцінювання за розділом",
   "performance-map-title": "Карта результативності",
   "assessment-results-per-organization-title": "Результати оцінювання за організацією",
   "module-results-per-organization-title": "Результати модуля за організацією",
   "section-results-per-organization-title": "Результати розділу за організацією",
   "assessment-targets-per-organization-title": "Цілі оцінювання за організацією",
   "module-targets-per-organization-title": "Цілі модуля за організацією",
   "section-targets-per-organization-title": "Цілі розділу за організацією",
   "improvement-tracker-per-organization-title": "Трекер покращення за організацією",
   "target-score-task-progress-per-organization-title": "Ціль, оцінка та прогрес завдань за організацією",
   "assessment-results-per-round-title": "Результати оцінювання за раундом",
   "module-results-per-round-title": "Результати модуля за раундом",
   "section-results-per-round-title": "Результати розділу за раундом",
   "assessment-targets-per-round-title": "Цілі оцінювання за раундом",
   "module-targets-per-round-title": "Цілі модуля за раундом",
   "section-targets-per-round-title": "Цілі розділу за раундом",
   "improvement-tracker-per-assessment-title": "Трекер покращення за оцінюванням",
   "target-score-task-progress-per-assessment-title": "Ціль, оцінка та прогрес завдань за оцінюванням",
   "radar-chart-type-label": "Радарна діаграма",
   "tier-list-type-label": "Список рівнів",
   "score-progress-across-rounds-title": "Динаміка результату за раундами",
   "module-score-progress-across-rounds-title": "Динаміка результату за модулями по раундах",
   "bar-chart-type-label": "Стовпчикова діаграма",
   "table-type-label": "Таблиця",
   "modules-word": "Модулі",
   "sections-word": "Розділи",
   "task-status-per-assessment-title": "Статус завдань за оцінюванням",
   "module-task-completion-title": "Виконання завдань модуля",
   "section-task-completion-title": "Виконання завдань розділу",
   "task-completion-per-organization-title": "Виконання завдань за організацією",
   "improvement-tracker-title": "Трекер покращення",
   "donut-chart-type-label": "Кільцева діаграма",
   "task-updated-success-message": "Завдання успішно оновлено.",
   "task-added-success-message": "Завдання успішно додано.",
   "export-tasks-error-message": "Виникла проблема під час експорту завдань, спробуйте ще раз.",
   "tasks-copied-success-title": "Завдання успішно скопійовано!",
   "tasks-copied-success-description": "Усі завдання з попереднього раунду скопійовано до поточного раунду.",
   "results-not-yet-approved-title": "Результати ще не затверджено!",
   "results-not-yet-approved-description": "Завдання можна копіювати лише після того, як усі модулі цього оцінювання матимуть затверджені подання. Будь ласка, затвердіть свої подання перед копіюванням завдань.",
   "tasks-already-copied-title": "Завдання вже скопійовано для цього раунду",
   "tasks-already-copied-description": "Завдання можна копіювати лише один раз за раунд. Якщо у вас відсутні завдання, зверніться до адміністратора.",
   "copy-tasks-error-title": "Ой! Виникла проблема!",
   "copy-tasks-error-description": "Виникла проблема під час копіювання завдань з попереднього раунду, спробуйте ще раз.",
   "resource-label-colon": "Ресурс:",
   "edit-module-alt-text": "Редагувати модуль",
   "delete-module-alt-text": "Видалити модуль",
   "task-status-updated-message": "Статус завдання оновлено.",
   "failed-update-task-status-message": "Не вдалося оновити статус завдання.",
   "plan-summary-title": "Підсумок плану",
   "select-organization-to-view-plan-text": "Виберіть організацію вище, щоб переглянути підсумок її плану.",
   "select-organization-placeholder": "Виберіть організацію",
   "previous-round-readonly-notice-text": "Це попередній раунд, доступний лише для перегляду, щоб зберегти його дані. Ви можете вносити зміни лише в поточному раунді.",
   "viewing-previous-round-button": "Ви переглядаєте попередній раунд",
   "go-to-current-round-button": "Перейти до поточного раунду",
   "staff-member-label": "Співробітник",
   "export-plan-button": "Експортувати план",
   "task-column-header": "Завдання",
   "responsible-column-header": "Відповідальний",
   "due-date-column-header": "Термін виконання",
   "see-less-link": "Показати менше",
   "see-all-link": "Показати всі",
   "no-linked-questions-text": "Немає пов'язаних питань",
   "resources-label-colon": "Ресурси:",
   "no-tasks-for-staff-member-text": "Не знайдено завдань для обраного співробітника",
   "add-tasks-improve-score-text": "Додайте завдання до цього показника, щоб покращити свій результат",
   "result-label-colon": "Результат:",
   "target-label-colon": "Ціль:",
   "review-note-added-success-description": "Примітку огляду успішно додано.",
   "reminder-set-title": "Нагадування встановлено",
   "reminder-scheduled-success-description": "Ваше нагадування успішно заплановано.",
   "review-notes-title": "Примітки огляду",
   "set-reminder-button": "Встановити нагадування",
   "print-summary-button": "Друкувати підсумок",
   "export-notes-button": "Експортувати примітки",
   "note-word": "Примітка",
   "no-note-created-yet-text": "Ще не створено жодної примітки.",
   "no-review-notes-available-text": "Немає доступних приміток огляду.",
   "no-score-selected-text": "Оцінку не вибрано",
   "filters-colon-label": "Фільтри:",
   "none-word": "Немає",
   "graph-word": "Графік",
   "no-chart-content-text": "Немає вмісту графіка",
   "filter-colon-label": "Фільтр:",
   "action-plan-word": "План дій",
   "results-word": "Результати",
   "no-charts-available-title": "Немає доступних графіків",
   "no-charts-data-export-text": "Немає графіків з даними, доступними для експорту.",
   "summary-action-plan-dashboard-title": "Підсумок панелі плану дій",
   "summary-results-dashboard-title": "Підсумок панелі результатів",
   "assessment-colon-label": "Оцінювання:",
   "assessment-word": "Оцінювання",
   "download-svg-action": "Завантажити SVG",
   "download-png-action": "Завантажити PNG",
   "included-in-report-tooltip-text": "Включається під час створення звіту",
   "no-visualization-selected-text": "Візуалізацію не вибрано",
   "drop-visualization-here-text": "Перетягніть візуалізацію сюди",
   "add-graph-button": "Додати графік",
   "delete-block-tooltip-text": "Видалити блок",
   "no-filters-selected-text": "Фільтри не вибрано",
   "filters-word": "Фільтри",
   "untitled-graph-text": "Графік без назви",
   "graph-preview-unavailable-text": "Попередній перегляд графіка недоступний",
   "filter-word": "Фільтр",
   "global-suffix-label": "(загальний)",
   "organization-word": "Організація",
   "staff-word": "Персонал",
   "generic-problem-occurred-title": "Ой! Виникла проблема",
   "view-saved-success-title": "Вигляд успішно збережено!",
   "view-saved-success-description": "Ваш вигляд панелі успішно збережено.",
   "problem-saving-view-description": "Виникла проблема під час збереження цього вигляду, спробуйте ще раз.",
   "select-view-before-rename-text": "Виберіть вигляд перед перейменуванням.",
   "select-view-before-delete-text": "Виберіть вигляд перед видаленням.",
   "view-deleted-success-title": "Вигляд успішно видалено!",
   "view-deleted-success-description": "Вибраний вигляд видалено з вашої панелі.",
   "problem-deleting-view-description": "Виникла проблема під час видалення цього вигляду, спробуйте ще раз.",
   "view-renamed-success-title": "Вигляд успішно перейменовано!",
   "view-renamed-success-description": "Назву вибраного вигляду успішно оновлено.",
   "problem-renaming-view-description": "Виникла проблема під час перейменування цього вигляду, спробуйте ще раз.",
   "view-word": "Вигляд",
   "compare-with-self-assessment-label": "Порівняти з самооцінюванням",
   "comparison-limited-one-org-text": "Це порівняння обмежено однією організацією одночасно",
   "assessment-not-linked-self-text": "Це оцінювання не пов'язане з самооцінюванням",
   "dashboard-word": "Панель",
   "self-assessments-menu-item": "Самооцінювання",
   "guided-assessments-menu-item": "Керовані оцінювання",
   "module-request-menu-item": "Запит модуля",
   "action-plan-menu-item": "План дій",
   "my-performance-menu-item": "Моя результативність",
   "task-management-menu-item": "Управління завданнями",
   "resources-menu-item": "Ресурси",
   "organization-management-menu-item": "Керування організацією",
   "quick-search-tooltip-text": "Швидкий пошук",
   "notifications-tooltip-text": "Сповіщення",
   "help-desk-word": "Служба підтримки",
   "go-back-previous-menu-text": "Повернутися до попереднього меню",
   "go-back-to-action-plan-link": "Повернутися до плану дій",
   "go-back-to-module-list-link": "Повернутися до списку модулів",
   "go-back-to-modules-list-link": "Повернутися до списку модулів",
   "go-back-to-templates-list-link": "Повернутися до списку шаблонів",
   "go-back-to-action-plan-section-link": "Повернутися до розділу плану дій",
   "go-back-to-assessment-link": "Повернутися до оцінювання",
   "go-back-to-assessments-link": "Повернутися до оцінювань",
   "go-back-to-assigned-modules-list-link": "Повернутися до списку призначених модулів",
   "go-back-to-approved-modules-list-link": "Повернутися до списку затверджених модулів",
   "go-back-to-pending-modules-list-link": "Повернутися до списку модулів в очікуванні",
   "go-back-to-guided-assessment-link": "Повернутися до керованого оцінювання",
   "go-back-to-guided-assessment-list-link": "Повернутися до списку керованих оцінювань",
   "go-back-to-workspaces-link": "Повернутися до робочих просторів",
   "profile-preview-alt-text": "Попередній перегляд профілю",
   "org-role-abbreviation": "Орг.",
   "role-super-admin-label": "Супер адміністратор",
   "role-consultant-label": "Консультант",
   "role-donor-label": "Донор",
   "role-national-organization-label": "Національна організація",
   "role-international-organization-label": "Міжнародна організація",
   "male-label": "Чоловіча",
   "female-label": "Жіноча",
   "no-self-assessments-here-text": "Тут немає самооцінювань",
   "no-guided-assessments-here-text": "Тут немає керованих оцінювань",
   "self-assessment-panel-title": "Самооцінювання",
   "guided-assessment-panel-title": "Кероване оцінювання",
   "sort-progress-by-label": "Сортувати прогрес за:",
   "highest-to-lowest-option": "Від найвищого до найнижчого",
   "lowest-to-highest-option": "Від найнижчого до найвищого",
   "modules-count-suffix": "модулів",
   "answer-pending-status": "Очікує відповіді",
   "unlock-assessment-text": "Розблокувати оцінювання",
   "select-assessment-see-results-text": "Виберіть оцінювання, щоб побачити його результати детально.",
   "linked-badge-label": "Пов'язано",
   "no-assessments-available-title": "Немає доступних оцінювань.",
   "start-adding-view-results-text": "Почніть, додавши одне, щоб побачити зібрані результати.",
   "assessment-selected-suffix": "оцінювання вибрано",
   "action-plan-panel-description-text": "Тут ви знайдете план дій на основі ваших результатів у кожному оцінюванні.",
   "select-one-see-plan-detail-text": "Виберіть одне, щоб побачити план детально.",
   "search-for-assessment-placeholder": "Пошук оцінювання",
   "areas-to-improve-label": "Модулі для покращення:",
   "no-assessments-here-text": "Тут немає оцінювань!",
   "selected-assessment-title": "Вибране оцінювання",
   "no-assessment-selected-text": "Оцінювання не вибрано",
   "number-of-resources-label": "Кількість ресурсів:",
   "areas-in-label": "Області:",
   "indicators-to-improve-label": "Показники для покращення:",
   "no-data-available-to-display-text": "Немає доступних даних для відображення.",
   "self-evaluate-screen-description-text": "Цей екран дозволяє вам оцінити себе на основі опитувальників, які ви заповнили",
   "maximum-organizations-warning-text": "Максимум 5 організацій!",
   "search-organization-placeholder": "Пошук організації",
   "sort-order-tooltip-text": "Порядок сортування",
   "get-results-tooltip-text": "Отримати результати",
   "report-word": "Звіт",
   "capacity-gaps-title": "Прогалини у спроможності",
   "capacity-gaps-description-text": "Які модулі та розділи сильні, а які слабкі, і як вони показують результати відносно своїх цілей.",
   "performance-overview-title": "Огляд результативності",
   "performance-overview-description-text": "Де перебуває когорта цього раунду: оцінки організацій, як вони розподіляються за категоріями оцінок оцінювання, і як вони співвідносяться з ціллю раунду.",
   "progress-across-rounds-title": "Прогрес між раундами",
   "progress-across-rounds-description-text": "Де опинилася когорта цього раунду на рівні розділу, і як змінилася кожна організація з попереднього раунду — хто покращився, хто знизився, і на скільки.",
   "action-plan-status-title": "Статус плану дій",
   "action-plan-status-description-text": "Виконання завдань по кожній організації за вибраний раунд, і як це пов'язано з досягненням цілі.",
   "score-band-deficient": "Незадовільно",
   "score-band-insufficient": "Недостатньо",
   "score-band-satisfactory": "Задовільно",
   "score-band-very-good": "Дуже добре",
   "score-band-excellent": "Відмінно",
   "module-rejected-success-description": "Модуль успішно відхилено",
   "failed-reject-module-description": "Не вдалося відхилити цей модуль",
   "module-accepted-success-description": "Модуль успішно затверджено",
   "failed-accept-module-description": "Не вдалося затвердити цей модуль",
   "module-requests-title": "Запити на модулі",
   "pending-modules-review-description-text": "Це список модулів, що очікують на ваш розгляд. Щоб продовжити, натисніть на кожен модуль, де ви зможете його прийняти або відхилити.",

   // Login / Registration pages
   "welcome-back-title": "З поверненням!",
   "login-into-account-subtitle": "Увійдіть у свій обліковий запис",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "Пароль",
   "toggle-password-visibility-label": "Показати/приховати пароль",
   "remember-me-label": "Запам'ятати мене?",
   "log-in-button": "Увійти",
   "no-account-yet-text": "Ще немає облікового запису?",
   "sign-up-link": "Зареєструватися",
   "max-16-symbols-validation": "Максимум 16 символів",
   "go-back-icon-alt": "Назад",
   "go-back-to-login-link": "Повернутися до входу",
   "welcome-to-kaporg-title": "Ласкаво просимо до KAPorg!",
   "which-profile-title": "Який профіль вам найбільше підходить?",
   "profile-organization-label": "Організація",
   "profile-donors-label": "Донори",
   "profile-expert-label": "Експерт",
   "signup-role-title": "Як ви використовуватимете KAPorg?",
   "signup-role-subtitle": "Оберіть роль, яка найкраще відповідає вашим обов'язкам.",
   "profile-donor-label": "Донор",
   "signup-role-organization-description": "Розбудовуйте сталу організаційну спроможність",
   "signup-role-donor-description": "Контролюйте ефективність інституційного портфеля",
   "signup-role-expert-description": "Надавайте незалежні стратегічні рекомендації",
   "signup-create-account-as-an": "Створіть обліковий запис як",
   "signup-create-account-as-a": "Створіть обліковий запис як",
   "showcase-login-headline": "Ми допомагаємо організаціям очолювати [[розвиток спроможності]]",
   "showcase-organization-headline": "Оцініть свої можливості та [[посильте свою місію]]",
   "showcase-donor-headline": "Контролюйте ефективність портфеля та [[досягайте вимірюваних результатів]]",
   "showcase-expert-headline": "Надавайте стратегічні рекомендації та [[зміцнюйте інституційну спроможність]]",
   "signup-step-profile": "Профіль",
   "signup-step-expertise": "Експертиза",
   "profile-details-title": "Дані профілю",
   "upload-photo-text": "Завантажити фото",
   "adjust-your-photo-title": "Налаштуйте фото",
   "change-photo-text": "Змінити фото",
   "signup-step-account": "Обліковий запис",
   "signup-step-contact": "Контакти",
   "enter-organization-email-placeholder": "Введіть електронну пошту організації",
   "code-must-have-6-digits-validation": "Код має містити 6 цифр",
   "code-incorrect-text": "Код неправильний",
   "confirmation-email-shortly-text": "Незабаром ви отримаєте лист із підтвердженням",
   "go-to-homepage-button": "На головну",
   "didnt-get-email-text": "Не отримали лист? Перевірте папку «Спам» або напишіть на",
   "language-selector-label": "Оберіть мову",
   "auth-tagline-transforming-title": "Трансформація розбудови потенціалу",
   "auth-tagline-transforming-description": "Для цифрової епохи",
   "auth-tagline-elevate-title": "Підвищте рівень своєї організації",
   "auth-tagline-elevate-description": "завдяки цілеспрямованій оцінці!",
   "auth-tagline-changemakers-title": "Зв'яжіться з тими, хто творить зміни",
   "auth-tagline-changemakers-description": "і найбільше потребує вас.",
   "auth-tagline-miss-you-title": "Нам буде вас бракувати,",
   "auth-tagline-miss-you-description": "Сподіваємося незабаром побачити вас знову.",
   "auth-tagline-collaborations-title": "Зануртеся у світ",
   "auth-tagline-collaborations-description": "впливової співпраці!",
   "auth-tagline-expertise-title": "Ваш досвід",
   "auth-tagline-expertise-description": "та ідеї рухають прогрес!",

   // National organization registration form
   "go-back-to-profile-selection-link": "Повернутися до вибору профілю",
   "create-account-title": "Створити обліковий запис",
   "as-an-org-label": "як Організація",
   "login-details-title": "Дані для входу",
   "confirm-password-label": "Підтвердіть пароль",
   "type-description-placeholder": "Введіть опис",
   "working-sectors-label": "Сектори діяльності",
   "enter-organization-name-placeholder": "Введіть назву організації",
   "enter-organization-address-placeholder": "Введіть адресу організації",
   "enter-organization-zip-code-placeholder": "Введіть поштовий індекс організації",
   "terms-agreement-prefix-text": "Я прочитав(-ла) та погоджуюсь з",
   "terms-of-service-privacy-policy-link": "Умовами надання послуг, Політикою конфіденційності",
   "and-conjunction-text": "та",
   "cookie-policy-link": "Політикою використання файлів cookie.",
   "invalid-email-address-validation": "Недійсна електронна пошта",
   "password-min-length-validation": "Пароль має містити щонайменше 8 символів",
   "password-complexity-validation": "Пароль має містити щонайменше одну велику літеру, одну цифру та один із зазначених символів !, @, #, $, %, ^, &, *",
   "password-required-validation": "Пароль обов'язковий",
   "passwords-must-match-validation": "Паролі мають збігатися",
   "confirm-password-required-validation": "Підтвердження пароля обов'язкове",
   "organization-name-required-validation": "Назва міжнародної організації обов'язкова",
   "foundation-year-required-validation": "Рік заснування обов'язковий",
   "sectors-min-validation": "Потрібно обрати щонайменше один сектор",
   "sectors-required-validation": "Сектори обов'язкові",
   "organization-address-required-validation": "Адреса організації обов'язкова",
   "invalid-organization-email-validation": "Недійсна електронна пошта організації",
   "organization-email-required-validation": "Електронна пошта організації обов'язкова",
   "accept-terms-required-validation": "Ви повинні прийняти умови та положення",

   // Donor registration form
   "as-an-international-donor-label": "як Міжнародний донор",
   "donor-organization-name-required-validation": "Назва організації обов'язкова",
   "invitation-code-label": "Код запрошення",
   "enter-invitation-code-placeholder": "Введіть ваш код запрошення",
   "invitation-code-min-length-validation": "Код запрошення має містити щонайменше 12 символів",
   "invitation-code-required-validation": "Код запрошення обов'язковий",
   "invalid-invitation-code-format-validation": "Недійсний формат коду запрошення",
   "no-invitation-code-help-text": "Якщо у вас немає коду запрошення, будь ласка, надішліть нам електронний лист сюди:",

   // Terms/Conditions modal
   "close-icon-alt": "Закрити",
   "terms-of-service-tab-label": "Умови надання послуг",
   "privacy-policy-tab-label": "Політика конфіденційності",
   "cookie-policy-tab-label": "Політика використання файлів cookie",
   "got-it-button": "Зрозуміло!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "Обліковий запис успішно створено.",
   "unexpected-error-description": "Сталася неочікувана помилка. Будь ласка, спробуйте ще раз.",
   "verification-code-sent-description": "Код підтвердження надіслано на вашу електронну пошту.",
   "expert-user-created-success-description": "Обліковий запис експерта успішно створено",

   // Expert registration step one
   "as-an-expert-label": "як Експерт",

   // Expert registration step three
   "lets-start-profile-info-title": "Почнімо з інформації про ваш профіль",
   "enter-full-name-placeholder": "Введіть ваше повне ім'я",
   "personal-statement-label": "Особиста заява/мотивація",
   "enter-personal-statement-placeholder": "Введіть вашу особисту заяву",
   "select-nationality-placeholder": "Оберіть вашу національність",
   "select-country-of-residence-placeholder": "Оберіть вашу країну проживання",
   "operating-countries-label": "Країни діяльності",
   "enter-linkedin-profile-placeholder": "Введіть ваш профіль LinkedIn",
   "full-name-required-validation": "Повне ім'я обов'язкове",
   "nationality-required-validation": "Національність обов'язкова",
   "country-of-residence-required-validation": "Країна проживання обов'язкова",

   // Expert registration step four
   "now-your-professional-details-title": "Тепер ваші професійні дані",
   "profile-picture-label": "Фото профілю",
   "education-section-title": "Освіта",
   "select-highest-degree-placeholder": "Оберіть здобутий вами найвищий ступінь",
   "enter-fields-of-study-placeholder": "Введіть галузі навчання",
   "enter-educational-institution-placeholder": "Введіть ваш навчальний заклад",
   "area-label": "Галузь",
   "enter-area-placeholder": "Введіть галузь",
   "add-another-area-button": "Додати ще одну галузь",
   "level-label": "Рівень",
   "select-level-placeholder": "Оберіть рівень",
   "add-another-language-button": "Додати ще одну мову",
   "upload-cv-label": "Завантажте своє резюме",
   "upload-certificate-label": "Завантажте сертифікат або спеціальне навчання",
   "remove-button": "Видалити",
   "image-file-type-badge": "JPG або PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "Найвищий ступінь обов'язковий",
   "area-required-validation": "Галузь обов'язкова",
   "years-of-experience-required-validation": "Роки досвіду обов'язкові",
   "years-of-experience-number-validation": "Роки досвіду мають бути числом",
   "profile-picture-required-validation": "Фото профілю обов'язкове",
   "invalid-image-file-type-validation": "Недійсний тип файлу. Дозволено лише PNG або JPEG.",
   "file-size-too-large-validation": "Розмір файлу завеликий. Максимальний розмір 20МБ.",
   "invalid-pdf-file-type-validation": "Недійсний тип файлу. Дозволено лише PDF.",
   "level-required-validation": "Рівень обов'язковий",
   "level-number-validation": "Рівень має бути числом",
   "go-back-to-profile-details-link": "Повернутися до деталей профілю",
   "uploaded-file-icon-alt": "Файл",
   "add-icon-alt": "Додати",

   // Confirm-code page
   "verification-code-title": "Код підтвердження",
   "verification-code-sent-to-text": "Будь ласка, введіть код підтвердження, який ми надіслали на",
   "verify-code-button": "Підтвердити код",
   "didnt-receive-code-text": "Якщо ви не отримали код підтвердження,",
   "resend-code-link": "натисніть тут, щоб надіслати його повторно",
   "or-send-email-at-text": "або надішліть нам електронний лист на",
   "verification-code-required-validation": "Код підтвердження обов'язковий",
   "code-verified-success-description": "Код успішно підтверджено",

   // Account on review page
   "account-on-review-icon-alt": "Обліковий запис на розгляді",
   "got-your-application-title": "Ми отримали вашу заявку!",
   "application-review-description-text": "Ви отримаєте електронний лист із підтвердженням, як тільки адміністратор схвалить ваш запит.",
   "in-the-meantime-prefix-text": "Тим часом відвідайте",
   "in-the-meantime-suffix-text": "для отримання додаткової інформації.",
   "thank-you-for-interest-text": "Дякуємо за ваш інтерес до KAPorg!",

   // Resources library
   "resources-library-tab-label": "Бібліотека ресурсів",
   "resource-type-all-label": "Усі ресурси",
   "resource-type-documents-label": "Документи",
   "resource-type-videos-label": "Відео",
   "resource-type-links-label": "Посилання",
   "resource-type-presentations-label": "Презентації",
   "no-resources-available-text": "Немає доступних ресурсів",
   "no-collections-available-text": "Немає доступних колекцій",
   "which-resource-looking-for-label": "Що ви шукаєте?",
   "search-ellipsis-placeholder": "Пошук...",
   "assessments-placeholder": "Оцінювання",
   "modules-label": "Модулі",
   "section-label": "Секція",
   "sections-placeholder": "Секції",
   "resource-icon-alt": "Ресурси",
   "copy-link-action": "Копіювати посилання",
   "edit-resource-icon-alt": "Редагувати ресурс",
   "rate-this-resource-action": "Оцінити цей ресурс",
   "delete-resource-icon-alt": "Видалити ресурс",
   "more-suffix-text": "ще",
   "rate-this-resource-title": "Оцінити цей ресурс",
   "resource-word": "Ресурс",
   "your-rating-label": "Ваша оцінка:",
   "save-rating-button": "Зберегти оцінку",
   "all-tab-label": "Усі",
   "my-collections-label": "Колекції",
   "my-collection-toggle-label": "Моя колекція",
   "all-collections-label": "Колекції",
   "edit-collection-icon-alt": "Редагувати колекцію",
   "delete-collection-icon-alt": "Видалити колекцію",
   "preview-colon-label": "Попередній перегляд:",
   "resources-word": "Ресурси",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "підсумок облікового запису",
   "account-summary-label": "Підсумок облікового запису",
   "account-summary-upgrade-message":
      "Ви наближаєтеся до ліміту свого пакета. Оновіть його, щоб отримати більше місця та створювати без обмежень.",
   "upgrade-package-button": "Оновити пакет",
   "modules-available-label": "Доступні модулі",
   "modules-created-label": "Створені модулі",
   "assessments-available-label": "Доступні оцінювання",
   "assessments-created-label": "Створені оцінювання",
   "workspaces-available-label": "Доступні робочі простори",
   "workspaces-created-label": "Створені робочі простори",
   "including-humanitarian-experts-created-label": "включно зі створеними гуманітарними експертами",
   "amount-of-storage-label": "Обсяг сховища",
   "data-usage-label": "Використання даних",
   "usage-statistics-label": "Статистика використання",
   "available-label": "Доступно",
   "used-label": "Використано",
   "profile-info-icon-alt": "інформація профілю",
   "profile-information-label": "Інформація профілю",
   "login-info-icon-alt": "інформація для входу",
   "login-information-label": "Інформація для входу",
   "payment-info-icon-alt": "інформація про оплату",
   "payment-information-label": "Інформація про оплату",
   "log-out-icon-alt": "вийти",
   "log-out-button": "Вийти",
   "account-menu-toggle-alt": "Меню облікового запису",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "Меню",
   "logo-alt-text": "Логотип",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "Позначити все як прочитане",
   "unread-tab-label": "Непрочитані",
   "no-notifications-title-text": "Тут немає сповіщень!",
   "up-to-date-description-text": "Все оновлено!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "Ці Умови надання послуг востаннє оновлювалися 4 березня 2024 року.",
   "terms-intro-websites-prefix-text": "Ці Умови надання послуг регулюють використання вами наших вебсайтів, розташованих за адресами",
   "terms-intro-websites-suffix-text": ", а також будь-яких пов'язаних послуг, що надаються International Advisory, Products and Systems Ltd. Отримуючи доступ до наших вебсайтів, ви погоджуєтеся дотримуватися цих Умов надання послуг та виконувати всі застосовні закони й нормативні акти. Якщо ви не погоджуєтеся з цими Умовами надання послуг, вам заборонено використовувати ці вебсайти або отримувати до них доступ, а також користуватися будь-якими іншими послугами, що надаються International Advisory, Products and Systems Ltd. Ми, International Advisory, Products and Systems Ltd, залишаємо за собою право переглядати та вносити зміни до будь-яких із цих Умов надання послуг на власний розсуд. Зробивши це, ми оновимо цю сторінку. Будь-які зміни до цих Умов надання послуг набувають чинності негайно з дати публікації.",
   "overview-of-services-title": "Огляд послуг",
   "overview-of-services-description-text": "International Advisory, Products and Systems Ltd. (i-APS), разом зі своїми афілійованими особами, включаючи, серед іншого, KAPsurvey, KAPorg, KAPinsights та KAPcourse (далі спільно іменовані «KAPtech Group»), надає послуги технічного консультування, інноваційні технологічні рішення та комплексні інструменти збору й аналізу даних. Пропозиції KAPtech Group спрямовані на підтримку виконання та управління експертними проєктами та проєктами розвитку. Ці послуги використовують найсучасніші технології та спираються на значний місцевий досвід, щоб допомогти партнерським організаціям і громадам ефективно реагувати на виклики в секторах експертної допомоги та розвитку й долати їх. Використовуючи послуги, що надаються KAPtech Group, включно з доступом до наших вебсайтів, ви погоджуєтеся дотримуватися умов, викладених у цій угоді, та бути ними зв'язаними. Пропоновані послуги регулюються умовами, викладеними у цьому документі, а також будь-якими додатковими вказівками чи правилами, застосовними до конкретних послуг або функцій послуг.",
   "limitations-of-use-title": "Обмеження щодо використання",
   "limitations-of-use-intro-text": "Використовуючи наші вебсайти, ви гарантуєте від свого імені, від імені своїх користувачів та інших сторін, яких ви представляєте, що ви не будете:",
   "limitation-modify-content-text": "змінювати, копіювати, готувати похідні твори, декомпілювати або застосовувати зворотну розробку до будь-яких матеріалів і програмного забезпечення, що містяться на цих вебсайтах;",
   "limitation-remove-notices-text": "видаляти будь-які позначення про авторські права чи інші майнові права з будь-яких матеріалів і програмного забезпечення на цих вебсайтах;",
   "limitation-transfer-materials-text": "передавати матеріали іншій особі або «дзеркалити» матеріали на будь-якому іншому сервері;",
   "limitation-abuse-networks-text": "свідомо або через недбалість використовувати ці вебсайти чи будь-які пов'язані з ними послуги у спосіб, що зловживає нашими мережами або будь-якою іншою послугою, яку надає International Advisory, Products and Systems Ltd, або порушує їх роботу;",
   "limitation-unlawful-material-text": "використовувати ці вебсайти чи пов'язані з ними послуги для передачі або публікації будь-яких матеріалів, що мають характер переслідування, є непристойними, розпусними, шахрайськими або незаконними;",
   "limitation-violate-laws-text": "використовувати ці вебсайти чи пов'язані з ними послуги з порушенням будь-яких застосовних законів або нормативних актів;",
   "limitation-spam-text": "використовувати ці вебсайти у зв'язку з розсиланням несанкціонованої реклами чи спаму;",
   "limitation-harvest-data-text": "збирати, накопичувати або отримувати дані користувачів без їхньої згоди; або",
   "limitation-infringe-rights-text": "використовувати ці вебсайти чи пов'язані з ними послуги у спосіб, що може порушувати приватність, права інтелектуальної власності або інші права третіх осіб",
   "intellectual-property-title": "Інтелектуальна власність",
   "intellectual-property-description-text": "Права інтелектуальної власності на матеріали, що містяться на цих вебсайтах, належать International Advisory, Products and Systems Ltd або надані їй за ліцензією та захищені застосовним законодавством про авторське право та товарні знаки. Ми надаємо нашим користувачам дозвіл завантажити одну копію матеріалів для особистого некомерційного тимчасового використання. Це є наданням ліцензії, а не передачею права власності. Дія цієї ліцензії автоматично припиняється у разі порушення вами будь-яких із цих обмежень або Умов надання послуг, і вона може бути припинена International Advisory, Products and Systems Ltd у будь-який час.",
   "user-generated-content-title": "Контент, створений користувачами",
   "terms-user-generated-content-description-text": "Ви зберігаєте за собою права інтелектуальної власності на контент, який ви надаєте нам для публікації на наших вебсайтах. Ми ніколи не претендуватимемо на право власності на ваш контент, однак нам потрібна ліцензія від вас для його використання. Коли ви використовуєте наші вебсайти чи пов'язані з ними послуги для розміщення, завантаження, поширення чи іншої передачі контенту, захищеного правами інтелектуальної власності, ви надаєте нам невиключну, безоплатну, таку, що підлягає передачі та субліцензуванню, всесвітню ліцензію на використання, розповсюдження, зміну, запуск, копіювання, публічне відображення, переклад або інше створення похідних творів з вашого контенту у спосіб, що відповідає вашим налаштуванням конфіденційності та нашій Політиці конфіденційності. Надана вами нам ліцензія може бути припинена в будь-який час шляхом видалення вашого контенту або облікового запису. Однак тією мірою, якою ми (або наші партнери) використовували ваш контент у зв'язку з комерційним або спонсорованим контентом, ліцензія залишатиметься чинною, доки ми не припинимо відповідний комерційний матеріал чи публікацію. Ви надаєте нам дозвіл використовувати ваше ім'я користувача та іншу ідентифікаційну інформацію, пов'язану з вашим обліковим записом, у спосіб, що відповідає вашим налаштуванням конфіденційності та нашій Політиці конфіденційності.",
   "registration-and-payments-title": "Реєстрація та платежі",
   "registration-and-payments-description-text": "Щоб користуватися будь-якою з наших послуг, вам необхідно створити обліковий запис. Будь-яка надана інформація має бути достовірною та, за потреби, оновленою. Клієнти несуть відповідальність за підтримання своїх облікових записів і повністю відповідають за всі дії, що здійснюються під їхніми обліковими записами. Якщо хтось отримає несанкціонований доступ до вашого облікового запису, ви повинні негайно повідомити нас про це. International Advisory, Products and Systems Ltd не несе відповідальності за будь-які втрати чи збитки, що виникли внаслідок неналежного забезпечення конфіденційності вашого облікового запису. Під час створення облікового запису вам необхідно надати фінансову інформацію, що відповідає обраному способу оплати. У деяких випадках вас можуть попросити надати дані вашої кредитної картки. Зверніть увагу, що будь-які платежі, здійснені на нашій платформі, обробляються PayPal, Stripe, Square, Google Payments або Apple Pay. У зв'язку з цим ми не несемо відповідальності за обробку чи зберігання будь-якої вашої фінансової інформації. PayPal, Stripe, Square, Google Payments або Apple Pay опрацьовуватимуть усю вашу фінансову інформацію відповідно до їхніх відповідних Умов надання послуг, і ви погоджуєтеся дотримуватися таких Умов надання послуг.",
   "disclaimer-and-limitations-title": "Відмова від відповідальності та обмеження відповідальності",
   "disclaimer-websites-prefix-text": "Вебсайти та матеріали, що надаються International Advisory, Products and Systems Ltd., включно з, серед іншого,",
   "disclaimer-as-is-description-text": ", надаються користувачам на умовах «як є». International Advisory, Products and Systems Ltd відмовляється від усіх гарантій, явних або непрямих, тією мірою, якою це дозволено законом. Це включає, серед іншого, гарантії придатності для продажу, придатності для певної мети або відсутності порушень прав інтелектуальної власності. Крім того, жодна порада чи інформація, усна чи письмова, отримана вами від International Advisory, Products and Systems Ltd або через послуги, не створює жодної гарантії, прямо не передбаченої цими умовами. International Advisory, Products and Systems Ltd та її постачальники не несуть відповідальності за будь-які прямі, непрямі, випадкові, спеціальні, опосередковані чи штрафні збитки, включно з, серед іншого, збитками через втрату прибутку, гудвілу, можливості використання, даних чи інших нематеріальних втрат (навіть якщо International Advisory, Products and Systems Ltd було повідомлено про можливість таких збитків), що виникли внаслідок використання або неможливості використання послуг чи будь-якого іншого питання, пов'язаного з послугами. Це обмеження відповідальності застосовується незалежно від того, чи ґрунтується заявлена відповідальність на договорі, деліктному праві, недбалості, суворій відповідальності чи будь-якій іншій підставі, навіть якщо International Advisory, Products and Systems Ltd було повідомлено про можливість таких збитків. З огляду на характер послуг, що надаються International Advisory, Products and Systems Ltd, особливо в контексті секторів експертної допомоги та розвитку, користувачі визнають наявність притаманних ризиків, пов'язаних зі збором даних та використанням технологічних рішень. Користувачі несуть одноосібну відповідальність за забезпечення дотримання всіх застосовних законів і нормативних актів, включно з, серед іншого, законодавством про захист даних і конфіденційність. Відповідальність за отримання необхідних згод і дозволів на збір даних, зокрема у випадках, що стосуються неповнолітніх осіб або конфіденційних даних, покладається на користувача. Відповідальність International Advisory, Products and Systems Ltd та її афілійованих осіб, директорів, посадових осіб, працівників, агентів, постачальників і ліцензіарів обмежується максимальною мірою, дозволеною законом. Якщо ви незадоволені будь-якою частиною послуг або будь-якими з цих умов, вашим єдиним і виключним засобом правового захисту є припинення використання послуг. У деяких юрисдикціях не допускається виключення певних гарантій або обмеження чи виключення відповідальності за випадкові чи непрямі збитки, тому деякі з наведених вище обмежень можуть на вас не поширюватися.",
   "accuracy-of-materials-title": "Точність матеріалів",
   "accuracy-of-materials-description-text": "Матеріали, розміщені на наших вебсайтах, не є вичерпними та призначені лише для загальної інформації. International Advisory, Products and Systems Ltd не гарантує та не робить жодних заяв щодо точності, ймовірних результатів чи надійності використання матеріалів на цих вебсайтах, а також щодо таких матеріалів чи будь-яких ресурсів, пов'язаних із цими вебсайтами. Вам не слід покладатися виключно на зазначені матеріали при прийнятті рішень; ми радимо звертатися до інших, повніших джерел інформації. Ви несете одноосібну відповідальність за суворе покладання на матеріали, розміщені на наших вебсайтах. Ми маємо право змінювати інформацію на наших вебсайтах без попереднього повідомлення, і користувачі відповідальні за відстеження таких змін.",
   "additional-tools-title": "Додаткові інструменти",
   "additional-tools-description-text": "Зверніть увагу, що наші вебсайти можуть включати сторонні інструменти, які перебувають поза нашим контролем. Доступ до зазначених інструментів надається на умовах «як є» без будь-яких гарантій, явних або непрямих, та без будь-якого схвалення. Ми не несемо відповідальності за використання сторонніх інструментів, наданих на наших вебсайтах. Ви несете одноосібну відповідальність за будь-які ризики, пов'язані з використанням зазначених інструментів; ми рекомендуємо ознайомитися з відповідними Умовами надання послуг стороннього постачальника. International Advisory, Products and Systems Ltd має право пропонувати нові сторонні інструменти в майбутньому",
   "links-title": "Посилання",
   "links-description-text": "International Advisory, Products and Systems Ltd не переглядала всі сайти, пов'язані з її вебсайтами посиланнями, і не несе відповідальності за вміст будь-якого такого пов'язаного сайту. Наявність будь-якого посилання не означає схвалення, погодження чи контролю з боку International Advisory, Products and Systems Ltd щодо такого сайту. Використання будь-якого такого пов'язаного сайту здійснюється на ваш власний ризик, і ми настійно радимо вам самостійно перевіряти придатність таких сайтів.",
   "inaccuracies-and-mistakes-title": "Неточності та помилки",
   "inaccuracies-and-mistakes-description-text": "Зверніть увагу, що будь-який контент, доступний на наших вебсайтах, може містити друкарські помилки, неточності або помилки, пов'язані з описом послуги, ціноутворенням, акціями та наявністю. Ми маємо право скасувати або оновити будь-які наявні послуги, якщо буде доведено, що будь-яка надана нами інформація є неточною. Зазначена інформація може бути змінена в будь-який час без попереднього повідомлення. Зверніть увагу, що ми не зобов'язані роз'яснювати будь-яку інформацію, пов'язану з нашими вебсайтами та послугами, включно з інформацією про ціни, за винятком випадків, коли це вимагається законом.",
   "indemnification-title": "Відшкодування збитків",
   "indemnification-description-text": "Ви погоджуєтеся захищати нас, відшкодовувати нам збитки та убезпечувати нас від відповідальності, включно з нашими дочірніми компаніями, афілійованими особами та всіма нашими відповідними посадовими особами, агентами, партнерами та працівниками, від будь-яких втрат, збитків, зобов'язань, претензій чи вимог, включно з обґрунтованими гонорарами та витратами адвокатів, заявлених будь-якою третьою стороною внаслідок або у зв'язку з: (1) вашими Внесками; (2) використанням вебсайтів; (3) порушенням цих Умов надання послуг; (4) будь-яким порушенням ваших заяв і гарантій, викладених у цих Умовах надання послуг; (5) вашим порушенням прав третьої сторони, включно з, серед іншого, правами інтелектуальної власності; або (6) будь-якою явною шкідливою дією щодо будь-якого іншого користувача вебсайтів, з яким ви встановили контакт через вебсайти.",
   "indemnification-defense-text": "Незважаючи на вищевикладене, ми залишаємо за собою право за ваш рахунок взяти на себе виключний захист і контроль у будь-якому питанні, щодо якого ви зобов'язані відшкодувати нам збитки, і ви погоджуєтеся співпрацювати, за ваш рахунок, з нашим захистом у таких претензіях. Ми докладатимемо розумних зусиль, щоб повідомити вас про будь-яку таку претензію, позов чи провадження, на які поширюється це відшкодування, після того, як нам стане про це відомо.",
   "right-to-terminate-title": "Право на розірвання",
   "right-to-terminate-description-text": "Ми можемо призупинити або припинити ваше право на використання наших вебсайтів і негайно розірвати ці Умови надання послуг шляхом письмового повідомлення вам у разі будь-якого порушення цих Умов надання послуг.",
   "severance-title": "Подільність положень",
   "severance-description-text": "Будь-яке положення цих Умов надання послуг, яке є повністю або частково недійсним чи таким, що не підлягає примусовому виконанню, відокремлюється тією мірою, якою воно є недійсним чи таким, що не підлягає примусовому виконанню. Це не впливає на чинність решти цих Умов надання послуг.",
   "entire-agreement-title": "Повна угода",
   "entire-agreement-description-text": "Ці Умови надання послуг та будь-які політики чи операційні правила, розміщені нами на вебсайтах або щодо вебсайтів, становлять повну угоду та взаєморозуміння між вами і нами. Наша нездатність реалізувати чи забезпечити виконання будь-якого права чи положення цих Умов надання послуг не вважається відмовою від такого права чи положення. Ці Умови надання послуг діють максимальною мірою, дозволеною законом. Ми можемо в будь-який час передати будь-які або всі наші права та зобов'язання іншим особам. Ми не несемо відповідальності за будь-які втрати, збитки, затримки чи бездіяльність, спричинені будь-якою причиною, що перебуває поза межами нашого розумного контролю. Якщо будь-яке положення чи частина положення цих Умов надання послуг буде визнано незаконним, недійсним чи таким, що не підлягає примусовому виконанню, таке положення чи частина положення вважається відокремлюваним від цих Умов надання послуг і не впливає на чинність та можливість примусового виконання решти положень. Ці Умови надання послуг або використання вебсайтів не створюють між вами і нами жодних відносин спільного підприємства, партнерства, найму чи представництва. Ви погоджуєтеся, що ці Умови надання послуг не тлумачитимуться проти нас на тій підставі, що ми їх склали. Цим ви відмовляєтеся від будь-яких і всіх заперечень, які ви можете мати, ґрунтуючись на електронній формі цих Умов надання послуг та відсутності підписання цих Умов надання послуг сторонами.",
   "governing-law-title": "Застосовне право",
   "governing-law-description-text": "Ці Умови надання послуг регулюються та тлумачаться відповідно до законодавства штату Virginia. Ви безповоротно погоджуєтеся на виключну юрисдикцію судів цього штату чи місцевості.",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "Останнє оновлення цих Умов надання послуг відбулося 4 березня 2024 року.",
   "cookie-intro-websites-prefix-text": "Ми використовуємо файли cookie, щоб покращити ваш досвід використання наших вебсайтів за адресою",
   "cookie-intro-websites-suffix-text": ". Ця політика використання файлів cookie є частиною політики конфіденційності International Advisory, Products and Systems Ltd. Вона регулює використання файлів cookie між вашим пристроєм і нашими сайтами.",
   "cookie-third-party-services-notice-text": "Ми також надаємо основну інформацію про сторонні сервіси, які можемо використовувати і які також можуть використовувати файли cookie в рамках своїх послуг. Ця політика не поширюється на їхні файли cookie.",
   "cookie-refuse-prefix-text": "Якщо ви не бажаєте приймати наші файли cookie, вам слід налаштувати браузер так, щоб він відхиляв файли cookie з",
   "cookie-refuse-suffix-text": ". У такому разі ми можемо бути не в змозі надати вам деякий бажаний контент і послуги.",
   "what-is-a-cookie-title": "Що таке файл cookie?",
   "cookie-definition-text": "Файл cookie — це невеликий фрагмент даних, який вебсайт зберігає на вашому пристрої під час відвідування. Зазвичай він містить інформацію про сам вебсайт, унікальний ідентифікатор, який дозволяє сайту розпізнати ваш веббраузер під час повторного відвідування, додаткові дані, що відповідають призначенню файла cookie, а також термін дії самого файла cookie.",
   "cookie-usage-examples-text": "Файли cookie використовуються для увімкнення певних функцій (наприклад, входу в систему), відстеження використання сайту (наприклад, аналітики), збереження ваших налаштувань користувача (наприклад, часового поясу, налаштувань сповіщень), а також для персоналізації контенту (наприклад, реклами, мови).",
   "first-party-cookies-definition-text": "Файли cookie, встановлені вебсайтом, який ви відвідуєте, зазвичай називають власними файлами cookie (first-party). Як правило, вони відстежують вашу активність лише на цьому конкретному сайті.",
   "third-party-cookies-definition-text": "Файли cookie, встановлені іншими сайтами та компаніями (тобто третіми сторонами), називаються сторонніми файлами cookie (third-party). Вони можуть використовуватися для відстеження вас на інших вебсайтах, які використовують той самий сторонній сервіс.",
   "cookie-types-title": "Типи файлів cookie та як ми їх використовуємо",
   "essential-cookies-definition-text": "Необхідні файли cookie мають вирішальне значення для вашої взаємодії з вебсайтом, оскільки забезпечують основні функції, такі як вхід користувача, керування обліковим записом, кошик покупок та обробка платежів.",
   "essential-cookies-usage-text": "Ми використовуємо необхідні файли cookie для забезпечення певних функцій на наших вебсайтах.",
   "performance-cookies-title": "Файли cookie продуктивності",
   "performance-cookies-definition-text": "Файли cookie продуктивності відстежують, як ви використовуєте вебсайт під час свого відвідування. Зазвичай ця інформація є анонімною та узагальненою, зібраною за всіма користувачами сайту. Вони допомагають компаніям розуміти моделі поведінки відвідувачів, виявляти та діагностувати проблеми чи помилки, з якими можуть стикатися їхні користувачі, а також ухвалювати кращі стратегічні рішення щодо покращення загального досвіду користувачів на вебсайті. Ці файли cookie можуть встановлюватися вебсайтом, який ви відвідуєте (власні), або сторонніми сервісами. Вони не збирають персональну інформацію про вас.",
   "performance-cookies-usage-text": "Ми використовуємо файли cookie продуктивності на наших сайтах.",
   "functionality-cookies-title": "Функціональні файли cookie",
   "functionality-cookies-definition-text": "Функціональні файли cookie використовуються для збору інформації про ваш пристрій та будь-які налаштування, які ви можете сконфігурувати на вебсайті, який відвідуєте (наприклад, налаштування мови та часового поясу). Завдяки цій інформації вебсайти можуть надавати вам індивідуалізований, покращений або оптимізований контент і послуги. Ці файли cookie можуть встановлюватися вебсайтом, який ви відвідуєте (власні), або сторонніми сервісами.",
   "functionality-cookies-usage-text": "Ми використовуємо функціональні файли cookie для окремих функцій на наших сайтах.",
   "targeting-advertising-cookies-title": "Таргетингові/рекламні файли cookie",
   "targeting-advertising-cookies-definition-text": "Таргетингові/рекламні файли cookie допомагають визначити, який рекламний контент є найбільш релевантним і відповідним для вас та ваших інтересів. Вебсайти можуть використовувати їх для показу таргетованої реклами або обмеження кількості разів, коли ви бачите те чи інше оголошення. Це допомагає компаніям підвищувати ефективність своїх кампаній та якість контенту, який вам пропонується. Ці файли cookie можуть встановлюватися вебсайтом, який ви відвідуєте (власні), або сторонніми сервісами. Таргетингові/рекламні файли cookie, встановлені третіми сторонами, можуть використовуватися для відстеження вас на інших вебсайтах, які використовують той самий сторонній сервіс.",
   "targeting-advertising-cookies-usage-text": "Ми використовуємо таргетингові/рекламні файли cookie на наших сайтах.",
   "control-cookies-title": "Як ви можете контролювати використання файлів cookie на нашому вебсайті?",
   "cookie-consent-manager-description-text": "Ви маєте право вирішувати, приймати чи відхиляти файли cookie на наших вебсайтах. Ви можете керувати своїми налаштуваннями файлів cookie у нашому Cookie Consent Manager. Cookie Consent Manager дозволяє вам обрати, які категорії файлів cookie ви приймаєте чи відхиляєте. Необхідні файли cookie не можуть бути відхилені, оскільки вони є суворо необхідними для надання вам послуг на наших вебсайтах.",
   "browser-settings-cookie-control-text": "Ви також можете встановити або змінити свої налаштування файлів cookie шляхом керування налаштуваннями вашого веббраузера. Оскільки кожен веббраузер відрізняється, будь ласка, зверніться до інструкцій, наданих вашим веббраузером (як правило, у розділі «довідка»). Якщо ви вирішите відхилити або вимкнути файли cookie, ви все одно зможете користуватися нашими вебсайтами, хоча деякі їхні функції можуть бути вам недоступні.",
   "cookie-policy-update-frequency-title": "Як часто ми оновлюємо цю Політику використання файлів cookie?",
   "cookie-policy-update-reason-text": "Ми можемо періодично оновлювати цю Політику використання файлів cookie, щоб відобразити будь-які зміни у файлах cookie та пов'язаних технологіях, які ми використовуємо, або з інших операційних, юридичних чи регуляторних причин.",
   "cookie-policy-version-notice-text": "Кожного разу, коли ви користуєтеся нашими вебсайтами, застосовується чинна версія Політики використання файлів cookie. Користуючись нашими вебсайтами, вам слід перевіряти дату цієї Політики використання файлів cookie (яка вказана на початку цього документа) і ознайомлюватися з будь-якими змінами з моменту останньої версії.",
   "cookie-policy-further-info-title": "Де ви можете отримати додаткову інформацію?",
   "cookie-policy-contact-us-description-text": "Якщо у вас виникли будь-які запитання чи занепокоєння щодо нашої Політики використання файлів cookie, ви можете зв'язатися з нами, скориставшись наведеними нижче контактними даними:",

   // Privacy Policy (legal document body)
   "information-we-collect-title": "Інформація, яку ми збираємо",
   "personal-information-definition-text": "Персональна інформація — це будь-яка інформація про вас, яка може бути використана для вашої ідентифікації. Це включає інформацію про вас як особу (таку як ім'я, адреса та дата народження), про ваші пристрої, платіжні дані, а також інформацію про те, як ви користуєтеся веб-сайтом чи онлайн-послугою.",
   "privacy-intro-websites-prefix-text": "Ваша конфіденційність важлива для нас. Політика International Advisory, Products and Systems Ltd полягає в тому, щоб поважати вашу конфіденційність та дотримуватися будь-якого застосовного законодавства й нормативних актів щодо будь-якої персональної інформації, яку ми можемо збирати про вас, у тому числі на наших веб-сайтах,",
   "privacy-intro-websites-suffix-text": ", та інших сайтах, якими ми володіємо та які ми експлуатуємо.",
   "privacy-last-updated-text": "Ці Умови надання послуг востаннє оновлювалися 4 березня 2024 року.",
   "third-party-sites-disclaimer-text": "У разі якщо наші сайти містять посилання на сторонні сайти та послуги, майте на увазі, що ці сайти та послуги мають власні політики конфіденційності. Перейшовши за посиланням на будь-який сторонній контент, вам слід ознайомитися з їхньою опублікованою політикою конфіденційності щодо того, як вони збирають та використовують персональну інформацію. Ця Політика конфіденційності не поширюється на будь-які ваші дії після того, як ви залишите один із наших сайтів.",
   "information-categories-intro-text": "Інформація, яку ми збираємо, поділяється на одну з двох категорій: інформація, яку «добровільно надано», та інформація, яку «автоматично зібрано»",
   "voluntarily-provided-info-description-text": "«Добровільно надана» інформація означає будь-яку інформацію, яку ви свідомо та активно надаєте нам під час використання будь-яких наших послуг та акцій або участі в них.",
   "automatically-collected-info-description-text": "«Автоматично зібрана» інформація означає будь-яку інформацію, автоматично надіслану вашими пристроями під час доступу до наших продуктів і послуг.",
   "log-data-title": "Дані журналів",
   "log-data-description-text": "Коли ви відвідуєте один із наших вебсайтів, наші сервери можуть автоматично реєструвати стандартні дані, що надаються вашим веббраузером. Це може включати IP-адресу (адресу Інтернет-протоколу) вашого пристрою, тип і версію вашого браузера, сторінки, які ви відвідуєте, час і дату вашого відвідування, час, витрачений на кожній сторінці, та інші відомості про ваше відвідування.",
   "log-data-errors-description-text": "Крім того, якщо під час використання наших сайтів ви стикаєтеся з певними помилками, ми можемо автоматично збирати дані про помилку та обставини, що супроводжували її виникнення. Ці дані можуть включати технічні відомості про ваш пристрій, дії, які ви намагалися виконати в момент виникнення помилки, та іншу технічну інформацію, що стосується проблеми. Ви можете отримати або не отримати повідомлення про такі помилки — навіть у момент їх виникнення, про сам факт їх виникнення чи про характер помилки.",
   "device-data-intro-text": "Коли ви відвідуєте наші веб-сайти або взаємодієте з нашими послугами, ми можемо автоматично збирати дані про ваш пристрій, зокрема:",
   "device-data-title": "Дані про пристрій",
   "device-type-label": "Тип пристрою",
   "log-data-combination-warning-text": "Звертаємо вашу увагу на те, що, хоча ця інформація сама по собі може не давати змоги ідентифікувати особу, її можливо поєднати з іншими даними для ідентифікації конкретних осіб.",
   "operating-system-label": "Операційна система",
   "unique-device-identifiers-label": "Унікальні ідентифікатори пристрою",
   "date-of-birth-label": "Дата народження",
   "device-data-settings-note-text": "Дані, які ми збираємо, можуть залежати від індивідуальних налаштувань вашого пристрою та програмного забезпечення. Ми рекомендуємо ознайомитися з політиками виробника вашого пристрою або постачальника програмного забезпечення, щоб дізнатися, яку інформацію вони надають нам.",
   "geo-location-data-label": "Дані про геолокацію",
   "personal-information-intro-text": "Ми можемо запитувати персональну інформацію — наприклад, коли ви підписуєтеся на нашу розсилку новин або коли звертаєтеся до нас, — яка може включати один або декілька з наведених нижче пунктів:",
   "personal-information-title": "Персональна інформація",
   "social-media-profiles-label": "Профілі в соціальних мережах",
   "phone-mobile-number-label": "Номер телефону/мобільного",
   "home-mailing-address-label": "Домашня/поштова адреса",
   "work-related-information-label": "Інформація, пов'язана з роботою",
   "company-name-label": "Назва компанії",
   "title-field-label": "Посада",
   "sensitive-information-title": "Чутлива інформація",
   "sensitive-information-definition-text": "«Чутлива інформація» або «спеціальні категорії даних» — це підмножина персональної інформації, якій надається вищий рівень захисту. Приклади чутливої інформації включають інформацію, що стосується вашого расового чи етнічного походження, політичних поглядів, релігії, членства у профспілках чи інших професійних асоціаціях, філософських переконань, сексуальної орієнтації, сексуальних практик чи статевого життя, судимостей, інформації про стан здоров'я або біометричної інформації.",
   "sensitive-information-types-intro-text": "Типи чутливої інформації про вас, яку ми можемо збирати, включають:",
   "sensitive-information-consent-text": "Ми не будемо збирати чутливу інформацію про вас без попереднього отримання вашої згоди, і ми будемо використовувати або розкривати вашу чутливу інформацію лише у випадках, дозволених, необхідних або санкціонованих законом.",
   "privacy-user-generated-content-description-text": "Ми вважаємо «контентом, створеним користувачем» матеріали (текстовий, графічний та/або відеоконтент), добровільно надані нам нашими користувачами з метою публікації, обробки або використання на нашій платформі. Весь контент, створений користувачем, пов'язується з обліковим записом або адресою електронної пошти, використаними для подання матеріалів.",
   "user-generated-content-publication-notice-text": "Майте на увазі, що будь-який контент, який ви подаєте з метою публікації, стане загальнодоступним після розміщення (і подальшого процесу перевірки чи модерації). Після публікації він може бути доступним третім особам, на яких не поширюється дія цієї політики конфіденційності.",
   "transaction-data-title": "Дані про транзакції",
   "transaction-data-description-text": "Дані про транзакції означають дані, які накопичуються в ході звичайного функціонування нашої платформи. Вони можуть включати записи про транзакції, збережені файли, профілі користувачів, аналітичні дані та інші показники, а також інші види інформації, створеної або згенерованої в процесі взаємодії користувачів з нашими послугами.",
   "legitimate-reasons-title": "Законні підстави для обробки Вашої персональної інформації",
   "legitimate-reasons-description-text": "Ми збираємо та використовуємо Вашу персональну інформацію лише за наявності законної підстави для цього. У такому випадку ми збираємо лише ту персональну інформацію, яка є обґрунтовано необхідною для надання Вам наших послуг.",
   "collection-and-use-title": "Збір та використання інформації",
   "collection-and-use-intro-text": "Ми можемо збирати Вашу персональну інформацію, якщо Ви вчиняєте будь-яку з наведених нижче дій на наших веб-сайтах:",
   "collect-register-account-text": "Зареєструвати обліковий запис",
   "collect-purchase-subscription-text": "Придбати підписку",
   "collect-signup-updates-text": "Підписатися на отримання оновлень від нас електронною поштою або через канали соціальних мереж",
   "collect-mobile-browser-text": "Використовувати мобільний пристрій або веб-браузер для доступу до нашого контенту",
   "collect-contact-us-text": "Зв'язатися з нами електронною поштою, через соціальні мережі або за допомогою будь-яких подібних технологій",
   "collect-social-media-mention-text": "Коли ви згадуєте нас у соціальних мережах",
   "collection-purposes-intro-text": "Ми можемо збирати, зберігати, використовувати та розкривати інформацію для таких цілей, при цьому персональні дані не будуть надалі оброблятися у спосіб, несумісний із цими цілями:",
   "purpose-core-features-text": "для надання вам основних функцій та послуг нашої платформи",
   "purpose-customize-experience-text": "для надання вам можливості налаштовувати або персоналізувати ваш досвід використання наших вебсайтів",
   "purpose-deliver-products-text": "для надання вам товарів та/або послуг",
   "purpose-contact-communicate-text": "для зв'язку та спілкування з вами",
   "purpose-analytics-research-text": "для аналітики, дослідження ринку та розвитку бізнесу, включаючи експлуатацію та вдосконалення наших вебсайтів, пов'язаних застосунків та пов'язаних платформ соціальних мереж",
   "purpose-advertising-marketing-text": "для реклами та маркетингу, у тому числі для надсилання вам рекламної інформації про наші продукти та послуги, а також інформації про третіх осіб, яка, на нашу думку, може становити для вас інтерес",
   "purpose-enable-access-text": "для надання вам можливості доступу до наших веб-сайтів, пов'язаних застосунків та пов'язаних платформ соціальних мереж, а також користування ними",
   "purpose-record-keeping-text": "для внутрішнього діловодства та адміністративних цілей",
   "purpose-legal-compliance-text": "для дотримання наших юридичних зобов'язань та вирішення будь-яких спорів, які можуть у нас виникнути",
   "purpose-attribute-content-text": "для зазначення авторства будь-якого контенту (наприклад, дописів і коментарів), який ви надсилаєте та який ми публікуємо на наших веб-сайтах",
   "purpose-security-fraud-text": "з метою безпеки та запобігання шахрайству, а також для забезпечення того, щоб наші сайти та застосунки були безпечними, захищеними та використовувалися відповідно до наших умов використання",
   "purpose-technical-assessment-text": "для технічної оцінки, включно з експлуатацією та вдосконаленням нашого додатка, пов'язаних застосунків та пов'язаних платформ соціальних медіа",
   "collection-combine-sources-text": "Ми можемо поєднувати добровільно надану та автоматично зібрану особисту інформацію із загальною інформацією або даними досліджень, які ми отримуємо з інших надійних джерел. Наприклад, якщо ви надасте нам інформацію про своє місцезнаходження, ми можемо поєднати її із загальною інформацією про валюту та мову, щоб забезпечити вам покращений досвід користування нашими сайтами та послугами.",
   "security-of-information-title": "Безпека вашої особистої інформації",
   "security-measures-description-text": "Коли ми збираємо та обробляємо особисту інформацію, а також протягом усього періоду її зберігання, ми захищатимемо її в межах комерційно прийнятних засобів для запобігання втраті та крадіжці, а також несанкціонованому доступу, розголошенню, копіюванню, використанню чи зміні.",
   "security-no-guarantee-text": "Хоча ми докладатимемо всіх зусиль для захисту наданої вами особистої інформації, повідомляємо, що жоден метод електронної передачі чи зберігання даних не є на 100% захищеним, і ніхто не може гарантувати абсолютну безпеку даних.",
   "security-password-responsibility-text": "Ви несете відповідальність за вибір будь-якого пароля та рівень його загальної надійності, забезпечуючи безпеку власної інформації в межах наших послуг. Наприклад, ви повинні забезпечувати безпеку та конфіденційність будь-яких паролів, пов'язаних із доступом до вашої особистої інформації та облікових записів.",
   "retention-period-title": "Як довго ми зберігаємо вашу особисту інформацію",
   "retention-period-description-text": "Ми зберігаємо вашу особисту інформацію лише протягом того часу, поки це необхідно. Цей строк може залежати від мети, з якою ми використовуємо вашу інформацію, відповідно до цієї політики конфіденційності. Наприклад, якщо ви надали нам особисту інформацію під час створення облікового запису у нас, ми можемо зберігати цю інформацію протягом усього періоду існування вашого облікового запису в нашій системі. Якщо ваша особиста інформація більше не потрібна для цієї мети, ми видалимо її або знеособимо, видаливши всі дані, що дозволяють вас ідентифікувати.",
   "retention-legal-obligation-text": "Однак, за необхідності, ми можемо зберігати вашу особисту інформацію з метою дотримання наших юридичних, бухгалтерських чи звітних зобов'язань, а також для цілей архівування в суспільних інтересах, наукових чи історичних досліджень або статистичних цілей.",
   "childrens-privacy-title": "Конфіденційність дітей",
   "childrens-privacy-description-text": "Жоден з наших продуктів чи послуг не спрямований безпосередньо на дітей віком до 13 років, і ми свідомо не збираємо особисту інформацію про дітей віком до 13 років.",
   "disclosure-to-third-parties-title": "Розкриття особистої інформації третім особам",
   "disclosure-intro-text": "Ми можемо розкривати персональні дані таким особам:",
   "disclose-affiliate-text": "материнській, дочірній компанії або афілійованій особі нашої компанії",
   "disclose-service-providers-text": "стороннім постачальникам послуг з метою надання їм можливості надавати свої послуги, включаючи (без обмежень) постачальників ІТ-послуг, постачальників послуг зберігання даних, хостингу та серверів, рекламні мережі, аналітичні служби, реєстратори помилок, колекторські компанії, постачальників послуг з технічного обслуговування або вирішення проблем, постачальників маркетингових або рекламних послуг, професійних консультантів та операторів платіжних систем",
   "disclose-employees-text": "нашим працівникам, підрядникам та/або пов'язаним особам",
   "disclose-business-partners-text": "нашим наявним або потенційним агентам чи діловим партнерам",
   "disclose-credit-agencies-text": "кредитним бюро, судам, трибуналам та регуляторним органам у разі, якщо Ви не сплатите за товари або послуги, надані нами Вам",
   "disclose-law-enforcement-text": "судів, трибуналів, регуляторних органів та працівників правоохоронних органів, якщо цього вимагає закон, у зв'язку з будь-яким фактичним або можливим судовим провадженням, або з метою встановлення, здійснення чи захисту наших законних прав",
   "disclose-agents-subcontractors-text": "третіх осіб, включаючи агентів або субпідрядників, які допомагають нам надавати вам інформацію, продукти, послуги або здійснювати прямий маркетинг",
   "disclose-collect-process-text": "третіх осіб для збору та обробки даних",
   "disclose-business-transfer-text": "суб'єкта, який купує або якому ми передаємо всі або практично всі наші активи та бізнес",
   "third-parties-currently-used-text": "Треті особи, яких ми наразі використовуємо, включають:",
   "international-transfers-title": "Міжнародна передача персональних даних",
   "international-transfers-description-text": "Персональна інформація, яку ми збираємо, зберігається та/або обробляється у Сполучених Штатах або в тих місцях, де ми, наші партнери, афілійовані особи та треті сторони-постачальники послуг мають свої об'єкти.",
   "international-transfers-legal-note-text": "Країни, в яких ми зберігаємо, обробляємо чи до яких передаємо вашу персональну інформацію, можуть не мати таких самих законів про захист даних, як країна, в якій ви первинно надали цю інформацію. Якщо ми передаємо вашу персональну інформацію третім особам в інших країнах: (i) ми здійснюємо такі передачі відповідно до вимог застосовного законодавства; та (ii) ми захищаємо передану персональну інформацію відповідно до цієї політики конфіденційності.",
   "your-rights-title": "Ваші права та контроль над вашою персональною інформацією",
   "your-choice-description-text": "Ваш вибір: надаючи нам персональну інформацію, ви розумієте, що ми збиратимемо, зберігатимемо, використовуватимемо та розкриватимемо вашу персональну інформацію відповідно до цієї політики конфіденційності. Ви не зобов'язані надавати нам персональну інформацію, однак, якщо ви цього не зробите, це може вплинути на можливість використання вами наших вебсайтів або продуктів та/або послуг, що пропонуються на них чи через них.",
   "info-from-third-parties-text": "Інформація від третіх осіб: якщо ми отримуємо персональну інформацію про вас від третьої особи, ми захищаємо її відповідно до положень цієї політики конфіденційності. Якщо ви є третьою особою, яка надає персональну інформацію про іншу особу, ви заявляєте та гарантуєте, що маєте згоду такої особи на надання нам її персональної інформації.",
   "marketing-permission-text": "Дозвіл на маркетинг: якщо ви раніше погодилися на використання нами вашої персональної інформації для цілей прямого маркетингу, ви можете в будь-який час змінити своє рішення, звернувшись до нас за контактними даними, наведеними нижче.",
   "access-rights-text": "Доступ: Ви можете звернутися до нас із запитом на отримання відомостей про персональну інформацію, яку ми зберігаємо про вас",
   "correction-rights-text": "Виправлення: Якщо ви вважаєте, що будь-яка інформація, яку ми зберігаємо про вас, є неточною, застарілою, неповною, недоречною або оманливою, будь ласка, зв'яжіться з нами, скориставшись контактними даними, наведеними в цій політиці конфіденційності. Ми вживемо розумних заходів для виправлення будь-якої інформації, яка виявиться неточною, неповною, оманливою або застарілою.",
   "non-discrimination-text": "Недискримінація: Ми не дискримінуватимемо вас у зв'язку з реалізацією будь-яких ваших прав щодо вашої персональної інформації. Якщо ваша персональна інформація не є необхідною для надання вам певної послуги чи пропозиції (наприклад, обробки даних транзакції), ми не відмовимо вам у товарах чи послугах та/або не стягуватимемо з вас іншу ціну чи тариф за товари чи послуги, у тому числі шляхом надання знижок чи інших переваг або накладення штрафів, а також не надамо вам товари чи послуги іншого рівня чи якості.",
   "download-personal-info-text": "Завантаження персональної інформації: Ми надаємо вам можливість завантажити персональну інформацію, якою ви поділилися через наші сайти. Будь ласка, зв'яжіться з нами для отримання додаткової інформації.",
   "data-breach-notification-text": "Повідомлення про порушення безпеки даних: Ми будемо дотримуватися законодавства, застосовного до нас, щодо будь-якого порушення безпеки даних.",
   "complaints-rights-text": "Скарги: Якщо ви вважаєте, що ми порушили відповідний закон про захист даних, і бажаєте подати скаргу, будь ласка, зв'яжіться з нами, скориставшись наведеними нижче контактними даними, та надайте нам повну інформацію про заявлене порушення. Ми оперативно розглянемо вашу скаргу та надамо вам письмову відповідь із зазначенням результатів нашого розслідування та заходів, яких ми вживемо для вирішення вашої скарги. Ви також маєте право звернутися до регуляторного органу або органу із захисту даних у зв'язку з вашою скаргою.",
   "unsubscribe-rights-text": "Відписка: Щоб відписатися від нашої бази даних електронної пошти або відмовитися від отримання повідомлень (включно з маркетинговими повідомленнями), будь ласка, зв'яжіться з нами, скориставшись контактними даними, наведеними в цій політиці конфіденційності, або скористайтеся засобами відмови від розсилки, передбаченими в самому повідомленні. Нам може знадобитися запросити у вас певну інформацію, щоб допомогти підтвердити вашу особу.",
   "use-of-cookies-title": "Використання файлів cookie",
   "use-of-cookies-description-text": "Ми використовуємо «файли cookie» для збору інформації про вас та вашу активність на наших сайтах. Файл cookie — це невеликий фрагмент даних, який наші веб-сайти зберігають на вашому комп'ютері та отримують доступ до нього щоразу, коли ви відвідуєте сайт, щоб ми могли зрозуміти, як ви користуєтеся нашими сайтами. Це допомагає нам надавати вам контент відповідно до вказаних вами уподобань.",
   "refer-to-cookie-policy-text": "Для отримання додаткової інформації, будь ласка, ознайомтеся з нашою Політикою щодо файлів cookie.",
   "business-transfers-title": "Передача бізнесу",
   "business-transfers-description-text": "Якщо нас або наші активи буде придбано, або в малоймовірному випадку припинення нашої діяльності чи банкрутства, ми віднесемо дані, зокрема вашу персональну інформацію, до складу активів, що передаються будь-яким сторонам, які нас придбають. Ви визнаєте, що така передача може відбутися, і що будь-які сторони, які нас придбають, можуть, у межах, дозволених застосовним законодавством, продовжувати використовувати вашу персональну інформацію відповідно до цієї політики, яку вони будуть зобов'язані прийняти, оскільки вона є підставою для будь-яких прав власності чи використання, які ми маємо щодо такої інформації.",
   "limits-of-policy-title": "Обмеження нашої Політики",
   "limits-of-policy-description-text": "Наші веб-сайти можуть містити посилання на зовнішні сайти, які не перебувають під нашим управлінням. Просимо звернути увагу, що ми не маємо контролю над змістом і політиками таких сайтів і не можемо нести відповідальність або зобов'язання за їхню практику щодо конфіденційності.",
   "changes-to-policy-title": "Зміни до цієї Політики",
   "changes-to-policy-description-text": "На власний розсуд ми можемо вносити зміни до нашої політики конфіденційності з метою відображення оновлень наших бізнес-процесів, чинної прийнятної практики або законодавчих чи нормативних змін. Якщо ми вирішимо змінити цю політику конфіденційності, ми опублікуємо зміни тут, за тим самим посиланням, за яким ви отримуєте доступ до цієї політики конфіденційності.",
   "changes-significant-notice-text": "Якщо зміни є суттєвими або якщо цього вимагає чинне законодавство, ми зв'яжемося з вами (відповідно до обраних вами налаштувань щодо отримання повідомлень від нас), а також з усіма нашими зареєстрованими користувачами, повідомивши нові деталі та надавши посилання на оновлену або змінену політику.",
   "changes-permission-text": "Якщо цього вимагає законодавство, ми отримаємо вашу згоду або надамо вам можливість, залежно від обставин, погодитися на нове використання ваших персональних даних чи відмовитися від нього.",
   "au-privacy-act-title": "Додаткові розкриття інформації для дотримання Закону Австралії про конфіденційність (AU)",
   "au-privacy-act-description-text": "У випадках, коли розкриття вашої особистої інформації регулюється виключно законодавством Австралії про конфіденційність, ви визнаєте, що деякі треті сторони можуть не підпадати під регулювання Закону Австралії про конфіденційність та Австралійських принципів конфіденційності, передбачених цим Законом. Ви визнаєте, що якщо будь-яка така третя сторона вчинить дію чи практику, яка порушує Австралійські принципи конфіденційності, вона не нестиме відповідальності згідно із Законом Австралії про конфіденційність, і ви не зможете вимагати відшкодування згідно із Законом Австралії про конфіденційність.",
   "gdpr-compliance-title": "Додаткові розкриття інформації для дотримання Загального регламенту про захист даних (GDPR) (ЄС)",
   "data-controller-processor-title": "Контролер даних / Обробник даних",
   "data-controller-processor-description-text": "GDPR розрізняє організації, які обробляють особисту інформацію для власних цілей (відомі як «контролери даних»), та організації, які обробляють особисту інформацію від імені інших організацій (відомі як «обробники даних»). Ми, International Advisory, Products and Systems Ltd, розташована за адресою, зазначеною в нашому розділі «Зв'яжіться з нами», є Контролером даних та/або Обробником даних щодо особистої інформації, яку ви нам надаєте.",
   "legal-bases-title": "Правові підстави для обробки вашої особистої інформації",
   "legal-bases-description-text": "Ми збиратимемо та використовуватимемо вашу персональну інформацію лише тоді, коли маємо законне право робити це. У такому разі ми збиратимемо та використовуватимемо вашу персональну інформацію законно, добросовісно та у прозорий спосіб. Якщо ми прагнемо отримати вашу згоду на обробку вашої персональної інформації, а вам ще не виповнилося 16 років, ми звертатимемося за згодою до ваших батьків або законного опікуна для обробки вашої персональної інформації з цією конкретною метою.",
   "legal-bases-grounds-text": "Наші правові підстави залежать від того, якими послугами ви користуєтеся та як саме ви їх використовуєте. Це означає, що ми збираємо та використовуємо вашу інформацію лише на таких підставах:",
   "consent-from-you-title": "Ваша згода",
   "consent-from-you-description-text": "У випадках, коли ви надаєте нам згоду на збір та використання вашої персональної інформації з конкретною метою. Ви можете відкликати свою згоду в будь-який час, скориставшись наданими нами засобами; однак це не вплине на будь-яке використання вашої інформації, яке вже відбулося. Ви можете надати згоду на надання своєї електронної адреси з метою отримання від нас маркетингових електронних листів. Хоча ви можете відписатися в будь-який час, ми не можемо відкликати жоден електронний лист, який ми вже надіслали. Якщо у вас виникнуть додаткові запитання щодо того, як відкликати свою згоду, будь ласка, звертайтеся, скориставшись контактними даними, наведеними в розділі «Зв’язатися з нами» цієї політики конфіденційності.",
   "performance-of-contract-title": "Виконання договору або транзакції",
   "performance-of-contract-description-text": "У випадках, коли ви уклали з нами договір або здійснили транзакцію, або з метою вжиття підготовчих заходів перед укладенням нами договору чи здійсненням транзакції з вами. Наприклад, якщо ви купуєте у нас продукт, послугу або підписку, нам може знадобитися використати вашу персональну інформацію та інформацію про платіж для обробки та доставки вашого замовлення.",
   "legitimate-interests-title": "Наші законні інтереси",
   "legitimate-interests-description-text": "У випадках, коли ми вважаємо це необхідним для реалізації наших законних інтересів, зокрема для надання, забезпечення функціонування, вдосконалення наших послуг та інформування про них. Ми вважаємо, що до наших законних інтересів належать дослідження та розробки, вивчення нашої аудиторії, маркетинг і просування наших послуг, заходи, спрямовані на ефективне забезпечення функціонування наших послуг, маркетинговий аналіз, а також заходи, спрямовані на захист наших законних прав та інтересів.",
   "compliance-with-law-title": "Дотримання законодавства",
   "compliance-with-law-description-text": "У деяких випадках ми можемо мати юридичний обов'язок використовувати або зберігати вашу персональну інформацію. Такі випадки можуть включати (але не обмежуються ними) судові рішення, кримінальні розслідування, запити державних органів та регуляторні зобов'язання. Якщо у вас виникнуть додаткові запитання щодо того, як ми зберігаємо персональну інформацію з метою дотримання законодавства, будь ласка, звертайтеся, скориставшись контактними даними, наведеними в розділі \"Зв'яжіться з нами\" цієї політики конфіденційності.",
   "eea-transfers-title": "Міжнародна передача даних за межі Європейської економічної зони (ЄЕЗ)",
   "eea-transfers-description-text": "Ми гарантуємо, що будь-яка передача персональної інформації з країн Європейської економічної зони (ЄЕЗ) до країн за межами ЄЕЗ буде захищена належними гарантіями, наприклад, шляхом використання стандартних договірних положень про захист даних, затверджених Європейською комісією, або застосування обов'язкових корпоративних правил чи інших юридично визнаних засобів.",
   "data-portability-text": "Переносимість даних: Ви можете мати право вимагати надання копії персональної інформації, яку ми зберігаємо про вас. За можливості ми надамо цю інформацію у форматі CSV або іншому легко читабельному машинному форматі. Ви також можете мати право вимагати, щоб ми передали цю персональну інформацію третій стороні.",
   "deletion-rights-text": "Видалення: Ви можете мати право вимагати, щоб ми видалили персональну інформацію, яку ми зберігаємо про вас, у будь-який час, і ми вживемо розумних заходів для видалення вашої персональної інформації з наших поточних записів. Якщо ви попросите нас видалити вашу персональну інформацію, ми повідомимо вам, як таке видалення вплине на використання вами наших вебсайтів або продуктів і послуг. Можуть існувати винятки з цього права з конкретних юридичних причин, які, якщо застосовно, ми викладемо вам у відповідь на ваш запит. Якщо ви припиняєте дію або видаляєте свій обліковий запис, ми видалимо вашу персональну інформацію протягом 45 днів з моменту видалення вашого облікового запису. Будь ласка, майте на увазі, що пошукові системи та подібні треті сторони можуть і надалі зберігати копії вашої персональної інформації, яка хоча б одного разу була оприлюднена, наприклад певна інформація профілю та публічні коментарі, навіть після того, як ви видалили цю інформацію з наших послуг або деактивували свій обліковий запис.",
   "objecting-to-processing-text": "Заперечення проти обробки: Ви маєте право заперечувати проти обробки вашої персональної інформації, яка ґрунтується на наших законних інтересах або суспільному інтересі. Якщо це буде зроблено, ми повинні надати переконливі законні підстави для обробки, які переважають ваші інтереси, права та свободи, щоб продовжити обробку вашої персональної інформації.",
   "restrict-processing-rights-text": "Обмеження: Ви маєте право вимагати, щоб ми обмежили обробку вашої персональної інформації, якщо (i) ви стурбовані точністю вашої персональної інформації; (ii) ви вважаєте, що ваша персональна інформація оброблялася незаконно; (iii) вам потрібно, щоб ми зберігали персональну інформацію виключно з метою юридичної претензії; або (iv) ми перебуваємо в процесі розгляду вашого заперечення щодо обробки на підставі законних інтересів.",
   "us-states-privacy-description-text": "Наступний розділ містить положення, що відповідають законам про конфіденційність цих штатів (California, Colorado, Delaware, Florida, Virginia та Utah) і застосовується лише до резидентів цих штатів. Конкретні посилання на певний штат (у заголовку або в тексті) є лише посиланням на закон цього штату та застосовуються лише до резидентів цього штату. Формулювання, що не стосуються конкретного штату, застосовуються до всіх перелічених вище штатів.",
   "us-states-privacy-title": "Додаткові розкриття інформації для відповідності законодавству про конфіденційність штатів США.",
   "do-not-track-title": "Не відстежувати",
   "do-not-track-description-text": "Деякі браузери мають функцію «Не відстежувати» («Do Not Track»), яка дозволяє повідомляти вебсайтам про те, що ви не бажаєте, щоб ваша діяльність в Інтернеті відстежувалася. На цей час ми не реагуємо на сигнали браузера «Не відстежувати».",
   "do-not-track-standards-text": "Ми дотримуємося стандартів, викладених у цій політиці конфіденційності, забезпечуючи збір та обробку персональних даних законно, добросовісно, прозоро та з наявністю легітимних, законних підстав для цього.",
   "cookies-and-pixels-title": "Файли cookie та піксельні теги",
   "cookies-and-pixels-description-text": "Ви завжди можете відмовитися від файлів cookie з наших сайтів, якщо це дозволяє ваш браузер. Більшість браузерів дозволяють налаштувати параметри браузера так, щоб відмовитися від встановлення всіх або деяких файлів cookie. Відповідно, ваша можливість обмежувати файли cookie залежить виключно від можливостей вашого браузера. Будь ласка, зверніться до розділу «Файли cookie» цієї політики конфіденційності для отримання додаткової інформації.",
   "california-privacy-laws-title": "Закони штату California про конфіденційність – CPPA",
   "california-privacy-financial-incentive-text": "Відповідно до розділу 1798.83 Цивільного кодексу California, якщо ви проживаєте в California і ваші ділові відносини з нами стосуються переважно особистих, сімейних чи побутових цілей, ви можете звернутися до нас із запитом щодо інформації, яку ми передаємо іншим організаціям для їхніх маркетингових цілей. Відповідно до вашого права на недискримінацію, ми можемо пропонувати вам певні фінансові стимули, дозволені Законом California про конфіденційність споживачів та Законом California про права на конфіденційність (разом — CCPA), що можуть призводити до різних цін, тарифів або рівнів якості товарів чи послуг, які ми надаємо. Будь-який дозволений CCPA фінансовий стимул, який ми пропонуємо, буде обґрунтовано пов'язаний із цінністю ваших персональних даних, і ми надамо письмові умови, які чітко описують характер такої пропозиції. Участь у програмі фінансових стимулів вимагає вашої попередньої явної згоди, яку ви можете відкликати в будь-який час.",
   "california-privacy-request-info-text": "Відповідно до розділу 1798.83 Цивільного кодексу California, якщо ви проживаєте в California і ваші ділові відносини з нами стосуються переважно особистих, сімейних чи побутових цілей, ви можете звернутися до нас із запитом щодо інформації, яку ми передаємо іншим організаціям для їхніх маркетингових цілей. Щоб подати такий запит, будь ласка, зв'яжіться з нами, використовуючи контактні дані, наведені в цій політиці конфіденційності, вказавши в темі повідомлення «Запит щодо інформації про конфіденційність California». Ви можете подавати такий запит один раз на календарний рік. Ми надішлемо вам електронною поштою перелік категорій персональних даних, які ми розкрили іншим організаціям для їхніх маркетингових цілей протягом останнього календарного року, а також їхні назви та адреси. Не всі персональні дані, розкриті таким чином, підпадають під дію розділу 1798.83 Цивільного кодексу California.",
   "california-notice-of-collection-title": "Повідомлення про збір даних California",
   "california-notice-of-collection-intro-text": "За останні 12 місяців ми зібрали такі категорії персональних даних, перелічені в CCPA:",
   "ccpa-identifiers-text": "Ідентифікатори, такі як ім'я, адреса електронної пошти, номер телефону, назва облікового запису, IP-адреса та ідентифікатор або номер, присвоєний вашому обліковому запису.",
   "ccpa-customer-records-text": "Записи про клієнтів, такі як адреса виставлення рахунків та доставки, а також дані кредитної або дебетової картки.",
   "ccpa-demographics-text": "Демографічні дані, такі як ваш вік або стать. Ця категорія включає дані, які можуть вважатися захищеними категоріями відповідно до інших законів штату California або федерального законодавства.",
   "ccpa-commercial-info-text": "Комерційна інформація, така як історія товарів чи послуг та покупки.",
   "ccpa-internet-activity-text": "Активність в Інтернеті, така як ваша взаємодія з нашим сервісом.",
   "ccpa-audio-visual-text": "Аудіо- або відеодані, такі як фотографії чи відео, якими ви ділитеся з нами або публікуєте на сервісі.",
   "ccpa-geolocation-text": "Дані геолокації.",
   "ccpa-employment-education-text": "Дані про працевлаштування та освіту, такі як дані, надані вами під час подання заявки на роботу до нас.",
   "ccpa-inferences-text": "Висновки, такі як інформація про ваші інтереси, уподобання та обране.",
   "california-notice-of-collection-outro-text": "Щоб отримати додаткову інформацію про дані, які ми збираємо, зокрема про джерела, з яких ми отримуємо інформацію, ознайомтеся з розділом «Інформація, яку ми збираємо». Ми збираємо та використовуємо ці категорії персональних даних для ділових цілей, описаних у розділі «Збір та використання інформації», зокрема для надання нашого Сервісу та управління ним.",
   "right-to-know-delete-title": "Право на отримання інформації та видалення даних",
   "right-to-know-delete-intro-text": "Ви маєте право на видалення персональних даних, які ми зібрали про вас, а також право дізнатися певну інформацію про наші практики обробки даних за попередні 12 місяців. Зокрема, ви маєте право вимагати від нас надання такої інформації:",
   "know-delete-categories-collected-text": "категорії персональних даних, які ми зібрали про вас;",
   "know-delete-categories-sources-text": "категорії джерел, з яких було зібрано персональні дані;",
   "know-delete-categories-disclosed-text": "Категорії персональної інформації про вас, яку ми розкрили з діловою метою або продали;",
   "know-delete-third-parties-text": "Категорії третіх осіб, яким персональна інформація була розкрита з діловою метою або продана;",
   "know-delete-business-purpose-text": "Ділова або комерційна мета збору чи продажу персональної інформації; та",
   "know-delete-specific-pieces-text": "Конкретні елементи персональної інформації, яку ми зібрали про вас.",
   "right-to-know-delete-outro-text": "Щоб скористатися будь-яким із цих прав, будь ласка, зв'яжіться з нами, використовуючи контактні дані, надані в цій політиці конфіденційності.",
   "shine-the-light-title": "Пролийте світло",
   "contact-us-title": "Зв'яжіться з нами",
   "customer-service-label": "Служба підтримки клієнтів",
   "privacy-contact-us-description-text": "Якщо у вас виникли будь-які запитання чи занепокоєння щодо вашої конфіденційності, ви можете зв'язатися з нами, скориставшись наведеними нижче контактними даними:",
   "shine-the-light-description-text": "Окрім прав, розглянутих вище, ви маєте право вимагати від нас надання інформації щодо того, яким чином ми передаємо певну особисту інформацію, визначену чинним законодавством, третім сторонам та афілійованим особам для їхніх власних цілей прямого маркетингу.",
   "shine-the-light-request-text": "Щоб отримати цю інформацію, надішліть нам запит, скориставшись контактними даними, наведеними в цій політиці конфіденційності. Запити повинні містити фразу «Запит щодо прав на конфіденційність» у першому рядку опису, а також містити ваше ім'я, вулицю та номер будинку, місто, штат і поштовий індекс.",

   // My Performance (Staff)
   "loading-ellipsis-text": "Завантаження...",
   "failed-to-load-modules-error": "Не вдалося завантажити модулі",
   "failed-to-load-details-error": "Не вдалося завантажити деталі",
   "my-assessments-title": "Мої оцінювання",
   "my-assessments-description-text":
      "Почніть з вибору оцінювання, щоб побачити його модулі та результати ефективності.",
   "no-assessments-yet-title": "Схоже, оцінювань поки немає!",
   "no-assessments-yet-description-text":
      "Коли оцінювання матимуть результати, вони з'являться тут для перегляду.",
   "modules-in-assessment-label": "Модулі в цьому оцінюванні:",
   "choose-module-to-see-results-text": "Виберіть модуль, щоб побачити результати",
   "status-closed-label": "Закрито",
   "select-module-alt-text": "Вибрати модуль",
   "select-module-results-text": "Виберіть модуль зі списку, щоб відобразити його результати",
   "target-label": "Ціль",
   "action-plan-label": "План дій",
   "assessment-preview-title": "Попередній перегляд оцінювання",
   "no-data-for-assessment-text": "Наразі немає доступних даних для цього оцінювання",
   "my-upcoming-tasks-title": "Мої майбутні завдання",
   "my-improvement-over-time-title": "Мій прогрес з часом",
   "no-data-for-survey-text": "Наразі немає доступних даних для цього опитування",
   "your-score-label": "Ваш бал",
   "target-score-label": "Цільовий бал",
   "previous-label": "Попередній",
   "next-label": "Наступний",

   // Task Management (Staff)
   "task-management-title": "Управління завданнями",
   "tasks-tab-label": "Завдання",
   "assigned-modules-title": "Призначені модулі",
   "collapse-all-button": "Згорнути все",
   "expand-all-button": "Розгорнути все",
   "assigned-tasks-title": "Призначені завдання",
   "board-tab-label": "Дошка",
   "timeline-tab-label": "Хронологія",
   "no-available-modules-text": "Немає доступних модулів для цього оцінювання",
   "no-available-tasks-text": "Немає доступних завдань для цього оцінювання",
   "go-alt-text": "Перейти",
   "view-alt-text": "Переглянути",
   "notes-alt-text": "Нотатки",
   "change-status-to-label": "Змінити статус на:",
   "priority-low-label": "Низький",
   "priority-medium-label": "Середній",
   "priority-high-label": "Високий",
   "priority-urgent-label": "Терміновий",
   "show-less-link": "Показати менше",
   "monthly-toggle-label": "Щомісячно",
   "quarterly-toggle-label": "Щоквартально",
   "week-prefix-text": "Тиждень",
   "to-do-status": "До виконання",
   "tasks-column-header": "Завдання",
   "linked-questions-prefix-text": "Пов'язані запитання:",
   "assigned-status": "Призначено",
   "action-plan-dashboard-title": "Панель плану дій",
   "action-plan-for-label": "План дій для",

   "role-vendor-label": "Постачальник",
   "switch-role-label": "Змінити роль",
   "current-role-label": "Поточна роль",
   "switch-role-error-description": "Не вдалося змінити роль, спробуйте ще раз.",
   "approver-role-added-to-existing-user-description":
      "Цей користувач уже мав обліковий запис, тому лист із запрошенням не надсилався. Він входить зі своїм наявним паролем і перемикається на роль затверджувача.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "Експерт",
   "expert-role-enabled-success-title": "Роль експерта додано",
   "expert-role-enabled-success-description": "Цей затверджувач тепер може також працювати як експерт.",
   "expert-role-disabled-success-title": "Роль експерта видалено",
   "expert-role-disabled-success-description": "Цей затверджувач більше не має ролі експерта.",
   "expert-role-toggle-error-description": "Не вдалося оновити роль експерта, спробуйте ще раз.",
   "expert-role-not-found-description": "Цього затверджувача більше не існує. Список оновлено.",
   "approver-role-column": "Затверджувач",
   "approver-role-enabled-success-title": "Роль затверджувача додано",
   "approver-role-enabled-success-description": "Цей експерт тепер може також працювати як затверджувач.",
   "approver-role-disabled-success-title": "Роль затверджувача видалено",
   "approver-role-disabled-success-description": "Цей експерт більше не має ролі затверджувача.",
   "approver-role-toggle-error-description": "Не вдалося оновити роль затверджувача, спробуйте ще раз.",
   "approver-role-not-found-description": "Цього експерта більше не існує. Список оновлено.",
   "expert-exists-redirect-title": "Вже є експертом",
   "expert-exists-redirect-description":
      "Ця електронна адреса вже належить експерту. Перенаправляємо вас до списку експертів, де ви можете надати йому роль затверджувача.",

   "linked-assessment-edit-notice":
      "Це оцінювання пов’язане з іншим, тому можна лише додавати нові раунди. Кожен доданий тут раунд додається й до пов’язаного оцінювання.",
   "start-date-in-past-validation": "Дата початку не може бути в минулому.",
   "end-date-must-be-future-validation": "Дата завершення має бути в майбутньому.",
   "round-overlaps-another-round-validation": "Цей раунд перетинається з іншим раундом.",
   "view-all-notifications-button": "Переглянути всі сповіщення",
   "notifications-page-title": "Сповіщення",
   "notifications-empty-title": "Сповіщень поки немає",
   "notifications-unread-empty-title": "Немає непрочитаних сповіщень",
   "notifications-empty-text": "Ви все переглянули. Нові сповіщення з'являтимуться тут.",
   "guided-assessment-completed-prefix-text": "Ваше кероване оцінювання",
   "guided-assessment-completed-suffix-text": "завершено.",
   "notification-title-org-signup": "Нова реєстрація організації",
   "notification-title-expert-signup": "Нова реєстрація експерта",
   "notification-title-workspace-join-request": "Запит організації на приєднання до робочого простору",
   "notification-title-workspace-approved": "Запит на робочий простір схвалено",
   "notification-title-workspace-rejected": "Запит на робочий простір відхилено",
   "notification-title-guided-request": "Запит на кероване оцінювання",
   "notification-title-guided-approved": "Запит на кероване оцінювання схвалено",
   "notification-title-guided-rejected": "Запит на кероване оцінювання відхилено",
   "notification-title-guided-completed": "Кероване оцінювання завершено",
   "notification-title-self-assigned": "Призначено нове самооцінювання",
   "notification-title-self-unassigned": "Самооцінювання знято",
   "notification-title-expert-assigned": "Призначено до керованого оцінювання",
   "notification-title-ticket-created": "Створено новий запит",
   "notification-title-ticket-updated": "Запит оновлено",
   "notification-title-submission-review": "Подання готове до перевірки",
   "notification-title-submission-approved-by-approver": "Подання схвалено затверджувачем",
   "notification-title-submission-rejected-by-approver": "Подання відхилено затверджувачем",
   "notification-title-module-assigned": "Призначено новий модуль",
   "notification-title-module-unassigned": "Модуль знято",
   "notification-title-submission-approved": "Подання схвалено",
   "notification-title-submission-rejected": "Подання відхилено",
   "notification-title-submission-approval": "Подання готове до затвердження",
   "mark-as-read-label": "Позначити як прочитане",
   "notification-actions-label": "Дії зі сповіщенням"
};
